//////LIBRARY//////
import _, { cloneDeep, filter, find, findIndex, isEmpty, isEqual, isNull, isNumber, isUndefined, map } from 'lodash'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useRouteMatch } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
//////COMPONENTS//////
import CalendarInputInline from '../../../components/CalendarInputInline'
import { LineTableHeader } from '../../../components/KioskPerimeter/KioskPerimeter'
import Modals from '../../../components/Modals'
import Tooltip from '../../../components/Tooltip/Tooltip'
import TooltipHelp from '../../../components/TooltipHelp/TooltipHelp'
import Button from '../../../components/Ui/Buttons'
import ToggleFilters from '../../../components/Ui/ToggleFilters'
import { kioskBusinessRequestStatusPicsConfig } from '../../../constants/AssetsPicturesConfigList'
import userPrivileges from '../../../constants/PrivilegesList'
import StringFormatter from '../../../helpers/StringFormatter'
import KioskPdvHelper from '../../../helpers/KioskPdvHelper'
import UseDatePicker from '../../../hooks/UseDatePicker'
import { uriList } from '../../../routings/settings/RouteList'
import { initKioskCreationDefinitionActionCreators } from '../../../store/actions'
import {
	ErrorInputMsg,
	InputLogin,
	InputWrapper,
	LabelText,
	OptionCustom,
	PageTitle,
	PageWrapperActionPrevPage,
	PageWrapperActions,
	PageWrapperGrids,
	PageWrapperLinks,
	SelectInputCustom,
	SelectInputWrapper,
	SpanTitle,
	TextareaStyled,
	TextModalList,
} from '../../../theme/GlobalCss'
import Theme from '../../../theme/theme'
import CompanyDetail from '../../CompanyDetail'
//////ASSETS//////
import AddRack from '../../../assets/icones/global/add.svg'
import Validation from '../../../assets/icones/global/check.svg'
import CloseEyeIcon from '../../../assets/icones/global/eye-close-blue.svg'
import DeleteRackIcon from '../../../assets/icones/global/trash-white.svg'
import OpenEyeIcon from '../../../assets/icones/global/view.svg'

//////STYLED//////
const KioskCreationDefinitionBusinessWrapper = styled.div`
	position: relative;
`
const TextModalWrapper = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`
const PageWrapperGridsCustom = styled(PageWrapperGrids)`
	grid-column-gap: 10px;
	& > div:last-child {
		border-right: none;
		padding-right: 0px;
	}
`
const KioskCreationDefinitionBusinessColumn = styled.div`
	font-size: ${(props) => props.theme.font.fs};
	border-right: 1px solid ${(props) => props.theme.colors.TabNav.border};
	padding-right: 10px;
	height: 100%;
`
const KioskCreationDefinitionBusinessPart = styled.div``

const KioskCreationDefinitionBusinessTitlePart = styled.span`
	line-height: 32px;
	height: 32px;
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) => props.theme.colors.primary};
	display: block;
	padding-left: 15px;
	font-weight: bold;
	margin-bottom: 10px;
	margin-top: 10px;
`
const KioskCreationDefinitionBusinessContentPart = styled.div`
	display: grid;
	grid-row-gap: 20px;
	grid-template-columns: auto;
	padding: 0px 10px 10px 10px;
	margin-top: 10px;
`
const KioskCreationDefinitionBusinessStatus = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	& > img {
		margin: 0px 6px;
		max-width: 16px;
		max-height: 16px;
	}
`
const KioskCreationDefinitionBusinessStockRequest = styled.div`
	& > div:first-child {
		display: flex;
		align-items: center;
		& > input {
			margin-right: 10px;
		}
	}
`
const KioskCreationDefinitionBusinessStockRequestQuantity = styled.div`
	display: flex;
	margin-top: 15px;
	align-items: center;
	& input {
		width: 56px;
		margin-left: 10px;
	}
`
const BuyoutDateHandler = styled.div`
	& > span {
		margin-bottom: 10px;
	}
`
const LabelTextCustom = styled(LabelText)`
	margin-bottom: 10px;
`
const UploadFileList = styled.div`
	& > div {
		display: grid;
		grid-template-columns: max-content min-content;
		grid-column-gap: 15px;
		align-items: center;
	}
	& > div > a {
		margin-bottom: 0px;
		height: 15px;
	}
`
const KioskCreationDefinitionBusinessInfo = styled.div`
	padding: 12px;
	background-color: ${(props) => (props.themed === 'white' ? 'transparent' : props.theme.infoPart.background)};
	border: ${(props) => (props.themed === 'white' ? `1px solid ${props.theme.infoPart.borderBlue}` : 'none')};
	& > div:first-child {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}
	& > div:first-child span {
		font-weight: bold;
		color: ${(props) => props.theme.colors.primary};
	}
	& > div:first-child img {
		cursor: pointer;
	}
`
const KioskCreationDefinitionBusinessInfoPart = styled.div`
	display: grid;
	grid-template-columns: max-content min-content;
	grid-column-gap: 15px;
	grid-row-gap: 5px;
`
const KioskCreationDefinitionBusinessTogglePart = styled.div`
	display: ${(props) => (props.visible ? 'grid' : 'none')};
	grid-template-columns: auto;
	grid-row-gap: 25px;
	margin: 20px 10px;
	& > div {
		display: flex;
		align-items: center;
		flex-direction: row;
		justify-content: space-between;
	}
`
const SelectInputDetailHandler = styled.div`
	& > div > a {
		position: absolute;
		right: -85px;
		text-decoration: underline;
		color: ${(props) => props.theme.colors.primary};
		cursor: pointer;
	}
	& > div {
		align-items: center;
	}
`
const KioskCodeWDLabel = styled.span`
	color: ${(props) => props.theme.colors.error};
	margin-left: 5px;
	line-height: 13px;
`

const PictureLink = styled.img`
	max-width: 20px;
	height: auto;
`
const PageWrapperLinksCustom = styled(PageWrapperLinks)`
	top: ${(props) => (props.rafterDisplayed ? '-130px' : '-90px')};
`
const KioskCreationDefinitionBusinessRacksInfoPart = styled.ul`
	list-style-type: none;
	padding: 0px;
	& > li {
		font-weight: ${(props) => (props.level === 0 ? 'bold' : 'normal')};
	}
	& > li > div {
		display: grid;
		grid-template-columns: 55% 45%;
	}
	& > li > div > span:first-child {
		margin-left: ${(props) => (props.level > 0 ? `${props.level * 30}px` : `0px`)};
	}
	& > li > div > span:nth-child(2) {
		color: ${(props) => (props.level > 0 ? props.theme.text.colors.primary : props.theme.colors.primary)};
	}
`
const KioskCreationDefinitionBusinessRacksPart = styled.div`
	display: grid;
	grid-template-columns: auto max-content;
	grid-row-gap: 25px;
`
const KioskCreationDefinitionBusinessRacksPartAccessory = styled.div`
	margin: 0px 25px;
	& > div {
		display: grid;
		grid-template-columns: auto auto;
		grid-column-gap: 10px;
		grid-row-gap: 25px;
	}
`
const AddRackButtonWrapper = styled.div`
	margin: auto;
`
const KioskCreationDefinitionBusinessRacksList = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-row-gap: 2px;
`
const KioskCreationDefinitionBusinessRackItem = styled.div`
	border-radius: 24px;
	background-color: ${(props) => (props.disabled ? props.theme.colors.eraser : props.theme.colors.primary)};
	padding: 13px 21px;
	& > span {
		color: ${(props) => props.theme.colors.white};
	}
	display: grid;
	grid-template-columns: max-content auto max-content;
	grid-column-gap: 15px;
	& > div > img {
		cursor: pointer;
	}
`
//////STYLED//////

const KioskCreationDefinitionBusiness = () => {
	const {
		user,
		translations,
		userKioskPerimeter,
		kioskCreation,
		kioskCreationDefinition,
		kioskCreationDefinitionOptions,
		updatedCompany,
		globalLoading,
	} = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			kioskCreation: state.initKioskCreation,
			kioskCreationDefinition: state.initKioskCreation.definition,
			kioskCreationDefinitionOptions: state.initKioskCreation.definition.availableOptions,
			updatedCompany: state.companyDetail.update,
			globalLoading: state.globalLoading,
		}),
		shallowEqual
	)

	const actionsInitKioskCreationDefinition = bindActionCreators(initKioskCreationDefinitionActionCreators, useDispatch())

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const history = useHistory()
	const match = useRouteMatch()

	const [isUpdate, setIsUpdate] = useState(false)
	const [isEditable, setIsEditable] = useState(false)
	const [isEditableSecondCycle, setIsEditableSecondCycle] = useState(false)
	const [customerValidated, setCustomerValidated] = useState(false)

	const [stockRequestCheck, setStockRequestCheck] = useState(false)

	const [requestStatusPict, setRequestStatusPict] = useState()

	// Detail modals info
	const [currentManufacturer, setCurrentManufacturer] = useState()
	const [currentOwner, setCurrentOwner] = useState()
	const [currentStoreManager, setCurrentStoreManager] = useState()
	const [currentReseller, setCurrentReseller] = useState()
	const [currentStore, setCurrentStore] = useState()
	const [currentDistributor, setCurrentDistributor] = useState()
	const [currentMaintainer, setCurrentMaintainer] = useState()

	// Account info
	const [showAccountInfo, setShowAccountInfo] = useState(true)
	// Store info
	const [showStoreInfo, setShowStoreInfo] = useState(true)
	// TechSupport info
	const [showTechSupportInfo, setShowTechSupportInfo] = useState(true)
	// Kiosk info
	const [showKioskInfo, setShowKioskInfo] = useState(false)
	// Kiosk config info
	const [showKioskConfigInfo, setShowKioskConfigInfo] = useState(false)
	// Customer racks info
	const [showCustomerRacksInfo, setShowCustomerRacksInfo] = useState(true)

	// Switches
	const [currentPageSwitches, setCurrentPageSwitches] = useState({})

	// Selected profile
	const [listProfiles, setListProfiles] = useState([])
	const [selectedProfile, setSelectedProfile] = useState({})

	// Available racks
	const [availableRackList, setAvailableRackList] = useState([])

	// Selected rack
	const [selectedRack, setSelectedRack] = useState({})

	// Added rack list
	const [addedRackList, setAddedRackList] = useState([])

	// Recap racks object - business view => dynamic
	const [recapRack, setRecapRack] = useState({
		foldedList: [],
		notFoldedList: [],
		smallLockerNumbers: 0,
		mediumLockerNumbers: 0,
		largeLockerNumbers: 0,
		extraLargeLockerNumbers: 0,
		accessoriesList: [],
	})

	// Recap racks object - customer infos => static
	const [recapRackCustomer, setRecapRackCustomer] = useState()

	// Date picker

	// For install and delivery date, we need to set prior start or prior end date,
	// based on each other
	// according to hot fix we don t' need to set a 35 days limit date, to prevent any side effect and
	// in case of we need to apply an other delay we prefer change value to add by 0
	const [limitInstallDate, setLimitInstallDate] = useState(moment().add('0', 'days').toDate())
	const [limitDeliveryDate, setLimitDeliveryDate] = useState(moment().toDate())

	const [
		dateInstallShowModal,
		dateInstallOpenDateModalHandler,
		dateInstallRenderModal,
		dateInstallStateDate,
		dateInstallStartDate,
		dateInstallEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		defaultDateStart: limitInstallDate /*moment().add(35,"days").toDate()*/,
		priorStartLimit: limitInstallDate,
	})

	const [buyoutDateShowModal, buyoutDateOpenDateModalHandler, buyoutDateRenderModal, buyoutDateStateDate, buyoutDateStartDate, buyoutDateEndDate] =
		UseDatePicker({
			noInterval: true,
			noTime: true,
			priorEndLimit: moment().toDate(),
			defaultDateStart: moment().toDate(),
		})

	const [
		dateDeliveryShowModal,
		dateDeliveryOpenDateModalHandler,
		dateDeliveryRenderModal,
		dateDeliveryStateDate,
		dateDeliveryStartDate,
		dateDeliveryEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		noPastDate: true,
		defaultDateStart: moment().toDate(),
		//priorEndLimit: limitDeliveryDate,
	})

	const [currentDateInstall, setCurrentDateInstallStateDate] = useState(dateInstallStateDate)
	const [currentBuyoutDate, setCurrentBuyoutDateStateDate] = useState(buyoutDateStateDate)
	const [currentDateDelivery, setCurrentDateDeliveryStateDate] = useState(dateDeliveryStateDate)

	// Default values of the form
	const [stateDefaultValues, setStateDefaultValues] = useState({
		quantity: null,
		kioskLanguage: '2',
	})
	const { register, handleSubmit, errors, watch, control, setValue, getValues, setError, clearErrors, unregister } = useForm({
		defaultValues: stateDefaultValues,
	})

	// Kiosk model	2eme cycle
	const [kisokModelSecondCycle, setKioskModelSecondCycle] = useState(map(kioskCreationDefinition?.data?.kioskModels, (e) => e.id))

	// Modals
	const [showModalManufacturerDetail, setShowModalManufacturerDetail] = useState(false)
	const [showModalOwnerDetail, setShowModalOwnerDetail] = useState(false)
	const [showModalStoreManagerDetail, setShowModalStoreManagerDetail] = useState(false)
	const [showModalStoreDetail, setShowModalStoreDetail] = useState(false)
	const [showModalDistributorDetail, setShowModalDistributorDetail] = useState(false)
	const [showModalResellerDetail, setShowModalResellerDetail] = useState(false)
	const [showModalCompanyCreate, setShowModalCompanyCreate] = useState(false)
	const [showModalCompaniesManager, setShowModalCompaniesManager] = useState(false)
	const [showModalMaintainerDetail, setShowModalMaintainerDetail] = useState(false)
	const [row, setRow] = useState({})

	/////////////////////////////// HANDLER //////////////////////////////////////

	// Modal handlers
	const handleOpenModals = (row = {}, modal) => {
		setRow(row)
		switch (modal) {
			case 'handleModalManufacturer':
				setShowModalManufacturerDetail(true)
				break
			case 'handleModalOwner':
				setShowModalOwnerDetail(true)
				break
			case 'handleModalReseller':
				setShowModalResellerDetail(true)
				break
			case 'handleModalStoreManager':
				setShowModalStoreManagerDetail(true)
				break
			case 'handleModalStore':
				setShowModalStoreDetail(true)
				break
			case 'handleModalDistributor':
				setShowModalDistributorDetail(true)
				break
			case 'handleModalMaintainer':
				setShowModalMaintainerDetail(true)
				break
			default:
				break
		}
	}

	const handleCloseModals = (_dataRow) => {
		if (showModalManufacturerDetail) {
			setShowModalManufacturerDetail(false)
		}
		if (showModalOwnerDetail) {
			setShowModalOwnerDetail(false)
		}
		if (showModalResellerDetail) {
			setShowModalResellerDetail(false)
		}
		if (showModalStoreManagerDetail) {
			setShowModalStoreManagerDetail(false)
		}
		if (showModalStoreDetail) {
			setShowModalStoreDetail(false)
		}
		if (showModalDistributorDetail) {
			setShowModalDistributorDetail(false)
		}
		if (showModalCompanyCreate) {
			setShowModalCompanyCreate(false)
		}
		if (showModalCompaniesManager) {
			setShowModalCompaniesManager(false)
		}
		if (showModalMaintainerDetail) {
			setShowModalMaintainerDetail(false)
		}
	}

	// Display status
	const findSubFlow = find(kioskBusinessRequestStatusPicsConfig, { subFlow: kioskCreationDefinition.data?.requestStatus?.subFlow })

	// Actions
	const handleRedirect = () => {
		history.push(`${uriList.initKiosks}${uriList.initKioskBusinessManager}`)
	}

	const onSubmitKiosk = (data, e) => {
		// here test if we have a value inside store in case of a disabled field to submit the store value
		let datas = cloneDeep(data)
		let datasFromStore = cloneDeep(kioskCreationDefinition.data)

		let test = filter(datasFromStore.salesmen, (e) => {
			if (e.selected) return e.id
		})[0]?.id
		datas.id = isUpdate ? match.params.id : kioskCreation.requestId ? kioskCreation.requestId : null
		//datas.userSeller = (!isUndefined(filter(datasFromStore.salesmen, e => { if(e.selected) return e.id})[0]?.id) &&  parseInt(datas.userSeller) ===  filter(datasFromStore.salesmen, e => { if(e.selected) return e.id})[0]?.id )    ?  filter(datasFromStore.salesmen, e => { if(e.selected) return e.id})[0]?.id : datas.userSeller
		datas.userSeller =
			(!isUndefined(
				filter(datasFromStore.salesmen, (e) => {
					if (e.selected) return e.id
				})[0]?.id
			) &&
				parseInt(datas.userSeller) ===
					filter(datasFromStore.salesmen, (e) => {
						if (e.selected) return e.id
					})[0]?.id) ||
			isUndefined(datas.userSeller)
				? filter(datasFromStore.salesmen, (e) => {
						if (e.selected) return e.id
				  })[0]?.id
				: datas.userSeller

		datas.requestName =
			(!isUndefined(datasFromStore.requestName) && !isUndefined(datasFromStore.requestName) === datas.requestName) ||
			isUndefined(datas.requestName)
				? datasFromStore.requestName
				: datas.requestName

		if (!isUndefined(datas.kioskDateInstallation)) datas.kioskDateInstallation = moment(currentDateInstall.date.startDate).toDate()
		if (!isUndefined(datas.buyoutDate)) datas.buyoutDate = moment(currentBuyoutDate.date.startDate).toDate()
		if (!isUndefined(datas.kioskDateDelivery)) datas.kioskDateDelivery = moment(currentDateDelivery.date.startDate).toDate()

		datas.quantity =
			stockRequestCheck && customerValidated ? kioskCreationDefinition.data.quantity : isEmpty(datas.quantity) ? null : parseInt(datas.quantity)

		datas.storeInformation = {
			manufacturer: parseInt(datas.manufacturer) > 0 ? parseInt(datas.manufacturer) : null,
			owner: parseInt(datas.owner) > 0 ? parseInt(datas.owner) : null,
			storeManager: parseInt(datas.storeManager) > 0 ? parseInt(datas.storeManager) : null,
			store: parseInt(datas.store) > 0 ? parseInt(datas.store) : null,
			distributor: parseInt(datas.distributor) > 0 ? parseInt(datas.distributor) : null,
			reseller: parseInt(datas.reseller) > 0 ? parseInt(datas.reseller) : null,
			maintainer: parseInt(datas.maintainer) > 0 ? parseInt(datas.maintainer) : null,
		}

		delete datas.manufacturer
		delete datas.owner
		delete datas.storeManager
		delete datas.store
		delete datas.distributor
		delete datas.reseller
		delete datas.maintainer

		datas.contactInformation = {
			currentUserPhoneNumber: datas.currentUserPhoneNumber,
			contactLastName: isUndefined(datasFromStore.progressInfo)
				? datas.contactLastName
				: datasFromStore.progressInfo.statusId === 19 && !isNull(datasFromStore.contactInformation.contactLastName)
				? datasFromStore.contactInformation.contactLastName
				: null,
			contactFirstName: isUndefined(datasFromStore.progressInfo)
				? datas.contactFirstName
				: datasFromStore.progressInfo.statusId === 19 && !isNull(datasFromStore.contactInformation.contactFirstName)
				? datasFromStore.contactInformation.contactFirstName
				: null,
			contactEmail: isUndefined(datasFromStore.progressInfo)
				? datas.contactEmail
				: datasFromStore.progressInfo.statusId === 19 && !isNull(datasFromStore.contactInformation.contactEmail)
				? datasFromStore.contactInformation.contactEmail
				: null,
			contactPhoneNumber: isUndefined(datasFromStore.progressInfo)
				? datas.contactPhoneNumber
				: datasFromStore.progressInfo.statusId === 19 && !isNull(datasFromStore.contactInformation.contactPhoneNumber)
				? datasFromStore.contactInformation.contactPhoneNumber
				: null,
		}

		//delete(datas.currentUserPhoneNumber)
		delete datas.contactLastName
		delete datas.contactFirstName
		delete datas.contactEmail
		delete datas.contactPhoneNumber

		datas.kioskInformation = {
			kioskModel: datas.kioskModel,
			kioskLabelToOwner: datas.kioskLabelToOwner,
			kioskDescription: datas.kioskDescription,
			kioskDateInstallation: datas.kioskDateInstallation,
			kioskLanguage: parseInt(datas.kioskLanguage) > 0 ? parseInt(datas.kioskLanguage) : null,
			welcomeMessage: datas.welcomeMessage,
			installationType: parseInt(datas.installationType) > 0 ? parseInt(datas.installationType) : null,
			kioskOwnerConfig: !isUndefined(
				filter(datasFromStore.kioskOwnerConfigs, (e) => {
					if (e.selected) return e.id
				})[0]?.id
			)
				? filter(datasFromStore.kioskOwnerConfigs, (e) => {
						if (e.selected) return e.id
				  })[0]?.id
				: datas.kioskOwnerConfig,
			bottleDetectionAvailable: datas.bottleDetectionAvailable,
			codePaymentAvailable: datas.codePaymentAvailable,
			tpaAvailable: datas.tpaAvailable,
			scaleAvailable: datas.scaleAvailable,
			printerAvailable: datas.printerAvailable,
			ticketByMailAvailable: datas.ticketByMailAvailable,
			solarPanelAvailable: datas.solarPanelAvailable,
			pda: datas.pda,
			solidDoor: datas.solidDoor,
			lateralPanel: datas.lateralPanel,
			interiorCover: datas.interiorCover,
			restrictedLocation: datas.restrictedLocation,
			bottleMatterSensor: datas.bottleMatterSensor,
			platineSet: datas.platineSet,
			marker: datas.marker,
			barCodeReader: datas.barCodeReader,
			kioskTpaIntegrator:
				(!isUndefined(
					filter(datasFromStore.integrator, (e) => {
						if (e.selected) return e.id
					})[0]?.id
				) &&
					filter(datasFromStore.integrator, (e) => {
						if (e.selected) return e.id
					})[0]?.id === datas.kioskTpaIntegrator) ||
				isUndefined(datas.kioskTpaIntegrator)
					? filter(datasFromStore.integrator, (e) => {
							if (e.selected) return e.id
					  })[0]?.id
					: datas.kioskTpaIntegrator > 0
					? datas.kioskTpaIntegrator
					: null,

			kioskTpaModel:
				(!isUndefined(
					filter(datasFromStore.tpaModel, (e) => {
						if (e.selected) return e.id
					})[0]?.id
				) &&
					filter(datasFromStore.tpaModel, (e) => {
						if (e.selected) return e.id
					})[0]?.id === parseInt(datas.kioskTpaModel)) ||
				isUndefined(datas.kioskTpaModel)
					? filter(datasFromStore.tpaModel, (e) => {
							if (e.selected) return e.id
					  })[0]?.id
					: parseInt(datas.kioskTpaModel) > 0
					? parseInt(datas.kioskTpaModel)
					: null,

			kioskWarranty: parseInt(datas.kioskWarranty) > 0 ? parseInt(datas.kioskWarranty) : null,
			kioskConnectivity:
				(!isUndefined(
					filter(datasFromStore.connectivity, (e) => {
						if (e.selected) return e.id
					})[0]?.id
				) &&
					filter(datasFromStore.connectivity, (e) => {
						if (e.selected) return e.id
					})[0]?.id === parseInt(datas.kioskConnectivity)) ||
				isUndefined(datas.kioskConnectivity)
					? filter(datasFromStore.connectivity, (e) => {
							if (e.selected) return e.id
					  })[0]?.id
					: parseInt(datas.kioskConnectivity) > 0
					? parseInt(datas.kioskConnectivity)
					: null,

			kioskDateDelivery: datas.kioskDateDelivery,
			idDisplayStandImplantation:
				(!isUndefined(
					filter(datasFromStore.displayStandsImplantation, (e) => {
						if (e.selected) return e.id
					})[0]?.id
				) &&
					filter(datasFromStore.displayStandsImplantation, (e) => {
						if (e.selected) return e.id
					})[0]?.id === datas.idDisplayStandImplantation) ||
				isUndefined(datas.idDisplayStandImplantation)
					? filter(datasFromStore.displayStandsImplantation, (e) => {
							if (e.selected) return e.id
					  })[0]?.id
					: datas.idDisplayStandImplantation,
			noteProduction: datas.noteProduction,
		}

		delete datas.kioskModel
		delete datas.kioskLabelToOwner
		delete datas.kioskDescription
		delete datas.kioskDateInstallation
		delete datas.kioskLanguage
		delete datas.welcomeMessage
		delete datas.installationType
		delete datas.kioskOwnerConfig
		delete datas.bottleDetectionAvailable
		delete datas.codePaymentAvailable
		delete datas.tpaAvailable
		delete datas.scaleAvailable
		delete datas.printerAvailable
		delete datas.ticketByMailAvailable
		delete datas.solarPanelAvailable
		delete datas.pda
		delete datas.solidDoor
		delete datas.lateralPanel
		delete datas.interiorCover
		delete datas.restrictedLocation
		delete datas.bottleMatterSensor
		delete datas.platineSet
		delete datas.marker
		delete datas.barCodeReader
		delete datas.kioskLabelToStore
		delete datas.kioskTpaIntegrator
		delete datas.kioskTpaModel
		delete datas.kioskWarranty
		delete datas.kioskConnectivity
		delete datas.kioskDateDelivery
		delete datas.idDisplayStandImplantation
		delete datas.noteProduction

		if (datas.userSeller <= 0) datas.userSeller = null

		datas.displayStandsInformation = map(addedRackList, (o) => {
			if (!isEmpty(o.accessoryDisplayStand)) {
				o.idAccessoryLockersNumber = o.accessoryDisplayStand[0].idAccessoryLockersNumber
				o.idAccessoryDisplayStandModel = o.accessoryDisplayStand[0].idAccessoryDisplayStandModel
			}
			return {
				idDisplayStandModel: parseInt(o.idDisplayStandModel),
				displayStandName: o.displayStandName,
				displayStandFolded: o.displayStandFolded,
				idAccessoryLockersNumber: parseInt(o.idAccessoryLockersNumber) > 0 ? parseInt(o.idAccessoryLockersNumber) : null,
				idAccessoryDisplayStandModel: parseInt(o.idAccessoryDisplayStandModel) > 0 ? parseInt(o.idAccessoryDisplayStandModel) : null,
				isMain: o.isMain,
				allowAccessoryRack: o.allowAccessoryRack,
				allowMultiMain: o.allowMultiMain,
				//message: o.message => message is now noteProduction, moved in kioskInformation object
			}
		})
		//}

		delete datas.idDisplayStandModel

		switch (e?.nativeEvent?.submitter?.id) {
			case 'ActionGenerateQuote':
				actionsInitKioskCreationDefinition.createDefinitionBusiness(datas)
				break
			case 'ActionCreate':
				actionsInitKioskCreationDefinition.createDefinitionBusiness(datas)
				break
			default:
				break
		}
	}

	const handleStockRequestCheck = () => {
		// To prevent check on required fields that are not displayed
		if (!stockRequestCheck)
			unregister(['installationType', 'kioskDateInstallation', 'kioskDateDelivery', 'kioskLanguage', 'reseller', 'store', 'storeManager'])
		setStockRequestCheck(!stockRequestCheck)
	}

	// When changing manufacturer
	const handleManufacturerChange = (idManufacturer) => {
		const f = find(kioskCreationDefinitionOptions.manufacturer, (o) => o.id === parseInt(idManufacturer))
		!isUndefined(f) && setCurrentManufacturer(f)
	}

	// When changing owner
	const handleOwnerChange = (idOwner) => {
		const f = find(kioskCreationDefinitionOptions.owner, (o) => o.id === parseInt(idOwner))
		!isUndefined(f) && setCurrentOwner(f)
		// Resetting selected profile
		//setListProfiles([])
		//setSelectedProfile({})
		// Also adding a back call to charge profiles
		//actionsInitKioskCreationDefinition.getProfilesConfigBusiness(idOwner)
	}

	// When changing store manager
	const handleStoreManagerChange = (idStoreManager) => {
		const f = find(currentOwner?.storesManager, (o) => o.id === parseInt(idStoreManager))
		!isUndefined(f) && setCurrentStoreManager(f)
	}

	// When changing store
	const handleStoreChange = (idStore) => {
		const f = find(currentOwner?.stores, (o) => o.id === parseInt(idStore))
		!isUndefined(f) && setCurrentStore(f)
	}

	// When changing distributor
	const handleDistributorChange = (idDistributor) => {
		const f = find(currentOwner?.distributors, (o) => o.id === parseInt(idDistributor))
		!isUndefined(f) && setCurrentDistributor(f)
	}

	// When changing reseller
	const handleResellerChange = (idReseller) => {
		const f = find(kioskCreationDefinitionOptions.reseller, (o) => o.id === parseInt(idReseller))
		!isUndefined(f) && setCurrentReseller(f)
	}

	// When changing maintainer
	const handleMaintainerChange = (idMaintainer) => {
		const f = find(currentOwner?.maintainers, (o) => o.id === parseInt(idMaintainer))
		!isUndefined(f) && setCurrentMaintainer(f)
	}

	// When selecting model
	const handleChangeKioskModel = (idKioskModel) => {
		actionsInitKioskCreationDefinition.getProfilesByKioskBusiness(idKioskModel)
	}

	// When selecting profile
	const handleChangeProfile = (idProfile) => {
		// If profile does not contain config (by loading a previous kiosk request)
		// Do a back call
		setAddedRackList([])
		setRecapRack({
			foldedList: [],
			notFoldedList: [],
			smallLockerNumbers: 0,
			mediumLockerNumbers: 0,
			largeLockerNumbers: 0,
			extraLargeLockerNumbers: 0,
			accessoriesList: [],
		})
		actionsInitKioskCreationDefinition.getProfileConfigBusiness(idProfile)
	}

	// When changing switch
	const handleSwitchChange = (switchElem) => {
		let pageSwitches = cloneDeep(currentPageSwitches)
		switch (switchElem) {
			case 'interiorCover':
				setValue('interiorCover', !pageSwitches.interiorCover)
				pageSwitches.interiorCover = !pageSwitches.interiorCover
				break
			case 'lateralPanel':
				setValue('lateralPanel', !pageSwitches.lateralPanel)
				pageSwitches.lateralPanel = !pageSwitches.lateralPanel
				break
			case 'pda':
				setValue('pda', !pageSwitches.pda)
				pageSwitches.pda = !pageSwitches.pda
				break
			case 'restrictedLocation':
				setValue('restrictedLocation', !pageSwitches.restrictedLocation)
				pageSwitches.restrictedLocation = !pageSwitches.restrictedLocation
				break
			case 'solidDoor':
				setValue('solidDoor', !pageSwitches.solidDoor)
				pageSwitches.solidDoor = !pageSwitches.solidDoor
				break
			default:
				break
		}
		setCurrentPageSwitches(pageSwitches)
	}

	// When changing profile config switch
	const handleProfileSelectedChange = (switchElem) => {
		let profile = cloneDeep(selectedProfile)
		switch (switchElem) {
			case 'bottleDetectionAvailable':
				setValue('bottleDetectionAvailable', !profile.bottleDetectionAvailable)
				profile.bottleDetectionAvailable = !profile.bottleDetectionAvailable
				break
			case 'codePaymentAvailable':
				setValue('codePaymentAvailable', !profile.codePaymentAvailable)
				profile.codePaymentAvailable = !profile.codePaymentAvailable
				break
			case 'tpaAvailable':
				setValue('tpaAvailable', !profile.tpaAvailable)
				profile.tpaAvailable = !profile.tpaAvailable
				break
			case 'scaleAvailable':
				setValue('scaleAvailable', !profile.scaleAvailable)
				profile.scaleAvailable = !profile.scaleAvailable
				break
			case 'printerAvailable':
				setValue('printerAvailable', !profile.printerAvailable)
				profile.printerAvailable = !profile.printerAvailable
				break
			case 'ticketByMailAvailable':
				setValue('ticketByMailAvailable', !profile.ticketByMailAvailable)
				profile.ticketByMailAvailable = !profile.ticketByMailAvailable
				break
			case 'solarPanelAvailable':
				setValue('solarPanelAvailable', !profile.solarPanelAvailable)
				profile.solarPanelAvailable = !profile.solarPanelAvailable
				break
			case 'platineSet':
				setValue('platineSet', !profile.platineSet)
				profile.platineSet = !profile.platineSet
				break
			case 'marker':
				setValue('marker', !profile.marker)
				profile.marker = !profile.marker
				break
			/*case "bottleColorSensor":
				setValue("bottleColorSensor", !profile.bottleColorSensor)
				profile.bottleColorSensor = !profile.bottleColorSensor
				break;
			case "bottleTopSensor":
				setValue("bottleTopSensor", !profile.bottleTopSensor)
				profile.bottleTopSensor = !profile.bottleTopSensor
				break;
			case "bottleBottomSensor":
				setValue("bottleBottomSensor", !profile.bottleBottomSensor)
				profile.bottleBottomSensor = !profile.bottleBottomSensor
				break;*/
			case 'bottleMatterSensor':
				setValue('bottleMatterSensor', !profile.bottleMatterSensor)
				profile.bottleMatterSensor = !profile.bottleMatterSensor
				break
			/*case "energyCard":
				setValue("energyCard", !profile.energyCard)
				profile.energyCard = !profile.energyCard
				break;*/
			case 'barCodeReader':
				setValue('barCodeReader', !profile.barCodeReader)
				profile.barCodeReader = !profile.barCodeReader
				break
			default:
				break
		}
		setSelectedProfile(profile)
	}
	const handleChangeRack = (idRack) => {
		let rack = find(availableRackList, { id: parseInt(idRack) })
		if (isUndefined(rack.displayStandFolded)) rack.displayStandFolded = false
		// If accessory fields exists, it means that we CAN add accessory, but it is not mandatory
		// In this case, we set it on false by default
		if (!isUndefined(rack.accessoryRack)) rack.accessoryRack = false
		setSelectedRack(rack)
	}

	// When changing rack model switch
	const handleRackModelSelectedChange = (switchElem) => {
		let rack = cloneDeep(selectedRack)

		switch (switchElem) {
			case 'displayStandFolded':
				rack.displayStandFolded = !rack.displayStandFolded
				break
			/*case "solar":
				rack.solar = !rack.solar
				break;*/
			case 'accessoryRack':
				rack.accessoryRack = !rack.accessoryRack
				break
			default:
				break
		}
		setSelectedRack(rack)
	}
	// When adding or removing rack to our list
	const handleRackList = (mode, keyRackDelete, labelDelete, labelAccessory) => {
		let listRacks = cloneDeep(addedRackList)
		let recapRackInfos = cloneDeep(recapRack)
		if (mode === 'add') {
			const nextIncrement = listRacks.length + 1
			const accessory = find(selectedRack.accessoryDisplayStandModels, (o) => o.id === parseInt(getValues('idAccessoryLockersNumber')))

			const rackToAdd = {
				idDisplayStandModel: selectedRack.id,
				displayStandName: `Rack WDCodeBorneWD-${nextIncrement}`,
				labelRack: selectedRack.label,
				labelAccessory: !isUndefined(accessory) ? translations[accessory.translationKey] : '',
				displayStandFolded: selectedRack.displayStandFolded,
				idAccessoryLockersNumber: getValues('idAccessoryLockersNumber'),
				idAccessoryDisplayStandModel: getValues('idAccessoryDisplayStandModel'),
				isMain: selectedRack.isMain,
				allowAccessoryRack: selectedRack.allowAccessoryRack,
				allowMultiMain: selectedRack.allowMultiMain,
				message: getValues('message'),
			}

			// Adding lockers number, folded or not
			if (selectedRack.displayStandFolded) {
				const f = findIndex(recapRackInfos.foldedList, (o) => o.label === selectedRack.label)
				const obj = find(recapRackInfos.foldedList, (o) => o.label === selectedRack.label)
				if (f === -1) {
					recapRackInfos.foldedList.push({
						id: selectedRack.id,
						label: selectedRack.label,
						count: 1,
						smallLockerNumbers: selectedRack.foldedSmallLockers,
						mediumLockerNumbers: selectedRack.foldedMediumLockers,
						largeLockerNumbers: selectedRack.foldedLargeLockers,
						extraLargeLockerNumbers: selectedRack.foldedExtraLargeLockers,
					})
				} else {
					obj.count++
					recapRackInfos.foldedList[f] = obj
				}

				// Adding locker numbers
				recapRackInfos.smallLockerNumbers += selectedRack.foldedSmallLockers
				recapRackInfos.mediumLockerNumbers += selectedRack.foldedMediumLockers
				recapRackInfos.largeLockerNumbers += selectedRack.foldedLargeLockers
				recapRackInfos.extraLargeLockerNumbers += selectedRack.foldedExtraLargeLockers
			} else {
				const f = findIndex(recapRackInfos.notFoldedList, (o) => o.label === selectedRack.label)
				const obj = find(recapRackInfos.notFoldedList, (o) => o.label === selectedRack.label)
				if (f === -1) {
					recapRackInfos.notFoldedList.push({
						id: selectedRack.id,
						label: selectedRack.label,
						count: 1,
						smallLockerNumbers: selectedRack.smallLockers,
						mediumLockerNumbers: selectedRack.mediumLockers,
						largeLockerNumbers: selectedRack.largeLockers,
						extraLargeLockerNumbers: selectedRack.extraLargeLockers,
					})
				} else {
					obj.count++
					recapRackInfos.notFoldedList[f] = obj
				}
				// Adding locker numbers
				recapRackInfos.smallLockerNumbers += selectedRack.smallLockers
				recapRackInfos.mediumLockerNumbers += selectedRack.mediumLockers
				recapRackInfos.largeLockerNumbers += selectedRack.largeLockers
				recapRackInfos.extraLargeLockerNumbers += selectedRack.extraLargeLockers
			}

			// Adding locker numbers for accessory
			// Check if accessory is existing ?
			const fAccIndex = findIndex(recapRackInfos.accessoriesList, (o) => (o.id = parseInt(rackToAdd.idAccessoryDisplayStandModel)))
			if (!isUndefined(getValues('idAccessoryDisplayStandModel'))) {
				if (fAccIndex === -1) {
					const objAccType = find(
						selectedRack.accessoryDisplayStandModels,
						(o) => o.id === parseInt(rackToAdd.idAccessoryDisplayStandModel)
					)
					const objAccCount = find(selectedRack.accessoryDisplayLockersNumber, (o) => o.id === parseInt(rackToAdd.idAccessoryLockersNumber))
					recapRackInfos.accessoriesList.push({
						id: parseInt(rackToAdd.idAccessoryDisplayStandModel),
						count: 1,
						countRacks: parseInt(objAccCount.label),
						label: objAccType.label,
					})
					recapRackInfos.smallLockerNumbers += parseInt(objAccCount.label)
				} else {
					recapRackInfos.accessoriesList[fAccIndex].count++
					recapRackInfos.smallLockerNumbers += parseInt(recapRackInfos.accessoriesList[fAccIndex].countRacks)
					//recapRackInfos.accessoriesList[fAccIndex].countRacks += parseInt(objAccCount.label)
				}
			}

			listRacks.push(rackToAdd)
		}
		if (mode === 'delete') {
			// See if our rack is folded ?
			let addedRack
			if (labelAccessory) {
				addedRack = find(
					addedRackList,
					(o) =>
						(o.labelRack === labelDelete && o.labelAccessory === labelAccessory) ||
						(translations[o.idDisplayStandModelName] === labelDelete && o.labelAccessory === labelAccessory)
				)
			} else {
				addedRack = find(addedRackList, (o) => o.labelRack === labelDelete || translations[o.idDisplayStandModelName] === labelDelete)
			}
			if (addedRack?.displayStandFolded) {
				const f = findIndex(recapRackInfos.foldedList, (o) => o.label === labelDelete)
				const obj = find(recapRackInfos.foldedList, (o) => o.label === labelDelete)
				if (f > -1) {
					obj.count--

					// Removing locker numbers
					recapRackInfos.smallLockerNumbers -= obj.smallLockerNumbers
					recapRackInfos.mediumLockerNumbers -= obj.mediumLockerNumbers
					recapRackInfos.largeLockerNumbers -= obj.largeLockerNumbers
					recapRackInfos.extraLargeLockerNumbers -= obj.extraLargeLockerNumbers

					if (obj.count === 0) recapRackInfos.foldedList = _.remove(recapRackInfos.foldedList, (o) => o.label !== labelDelete)
					else recapRackInfos.foldedList[f] = obj
				}
			} else {
				const f = findIndex(recapRackInfos.notFoldedList, (o) => o.label === labelDelete)
				const obj = find(recapRackInfos.notFoldedList, (o) => o.label === labelDelete)
				if (f > -1) {
					obj.count--

					// Removing locker numbers
					recapRackInfos.smallLockerNumbers -= obj.smallLockerNumbers
					recapRackInfos.mediumLockerNumbers -= obj.mediumLockerNumbers
					recapRackInfos.largeLockerNumbers -= obj.largeLockerNumbers
					recapRackInfos.extraLargeLockerNumbers -= obj.extraLargeLockerNumbers

					if (obj.count === 0) recapRackInfos.notFoldedList = _.remove(recapRackInfos.notFoldedList, (o) => o.label !== labelDelete)
					else recapRackInfos.notFoldedList[f] = obj
				}
			}

			// Also removing accessories locker from count
			if (!isUndefined(addedRack?.idAccessoryDisplayStandModel) || labelAccessory.length > 0) {
				const fAcc = find(recapRackInfos.accessoriesList, (o) => o.id === parseInt(addedRack?.idAccessoryDisplayStandModel))
				const fAccIndex = findIndex(recapRackInfos.accessoriesList, (o) => o.id === parseInt(addedRack?.idAccessoryDisplayStandModel))
				if (!isUndefined(fAcc)) {
					fAcc.count--
					recapRackInfos.smallLockerNumbers -= parseInt(fAcc.countRacks)
					if (fAcc.count === 0)
						recapRackInfos.accessoriesList = _.remove(
							recapRackInfos.accessoriesList,
							(o) => o.id !== parseInt(addedRack?.idAccessoryDisplayStandModel)
						)
					else recapRackInfos.accessoriesList[fAccIndex] = fAcc
				}
			}

			_.remove(listRacks, (_o, key) => key === parseInt(keyRackDelete))
		}

		// Controlling presences of main racks, multi main racks, etc...
		const mainRackCount = _.countBy(listRacks, (o) => o.isMain)
		const multiMainRackCount = _.countBy(listRacks, (o) => o.allowMultiMain)

		// No main or multi main => complete reset
		if (isUndefined(mainRackCount.true) && isUndefined(multiMainRackCount.true)) {
			recapRackInfos = {
				foldedList: [],
				notFoldedList: [],
				smallLockerNumbers: 0,
				mediumLockerNumbers: 0,
				largeLockerNumbers: 0,
				extraLargeLockerNumbers: 0,
				accessoriesList: [],
			}
			listRacks = []
		}
		// If multimain count is the same of main count, it means that we can't have secondary racks anymore
		else if (
			!isUndefined(mainRackCount.true) &&
			!isUndefined(multiMainRackCount.true) &&
			mainRackCount.true === multiMainRackCount.true &&
			listRacks.length > 1
		) {
			let newListRacks = cloneDeep(listRacks)
			// Automatically removing secondary racks
			listRacks.forEach((elem, _key) => {
				if (!elem.isMain) {
					const idRack = elem.idDisplayStandModel // It is his id, not the index of element !
					const folded = elem.displayStandFolded
					const accStore = find(availableRackList, (o) => o.id === idRack)
					if (folded) {
						recapRackInfos.foldedList = filter(recapRackInfos.foldedList, (o) => {
							return o.id !== idRack
						})
						// And removing lockers numbers...
						recapRackInfos.smallLockerNumbers -= accStore.foldedSmallLockers
						recapRackInfos.mediumLockerNumbers -= accStore.foldedMediumLockers
						recapRackInfos.largeLockerNumbers -= accStore.foldedLargeLockers
						recapRackInfos.extraLargeLockerNumbers -= accStore.foldedExtraLargeLockers
					} else {
						recapRackInfos.notFoldedList = filter(recapRackInfos.notFoldedList, (o) => {
							return o.id !== idRack
						})
						// And removing lockers numbers...
						recapRackInfos.smallLockerNumbers -= accStore.smallLockers
						recapRackInfos.mediumLockerNumbers -= accStore.mediumLockers
						recapRackInfos.largeLockerNumbers -= accStore.largeLockers
						recapRackInfos.extraLargeLockerNumbers -= accStore.extraLargeLockers
					}

					// Handling accessories
					if (!isUndefined(elem.idAccessoryDisplayStandModel)) {
						const fAcc = find(recapRackInfos.accessoriesList, (o) => o.id === parseInt(elem.idAccessoryDisplayStandModel))

						if (!isUndefined(fAcc)) {
							recapRackInfos.accessoriesList = _.remove(
								recapRackInfos.accessoriesList,
								(o) => o.id !== parseInt(elem.idAccessoryDisplayStandModel)
							)
						}
					}

					newListRacks = _.remove(newListRacks, (o) => o.idDisplayStandModel !== idRack)
				}
				//return elem
			})
			listRacks = newListRacks
			// Reincrement rack list on delete
			listRacks.forEach((elem, key) => {
				elem.displayStandName = `Rack WDCodeBorneWD-${key + 1}`
				return elem
			})
		}
		setValue('idDisplayStandModel', 0)
		setSelectedRack({})
		setRecapRack(recapRackInfos)
		setAddedRackList(listRacks)
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	const extractRacksInformations = (mode = 'customer') => {
		const extractData =
			mode === 'manufacturer'
				? kioskCreationDefinition.data.manufacturerDisplayStandInformation
				: kioskCreationDefinition.data.customerDisplayStandInformation

		// Getting racks information
		let notFoldedList = []
		extractData.displayStandTypes[0].displayStandModel.forEach((elem) => {
			let elemToAdd = {}
			if (elem.displayStandTypeModelNumber > 0) {
				const obj = find(selectedProfile.displayStandConfig, (o) => o.translationKey === elem.displayStandModel)
				if (!isUndefined(obj)) {
					elemToAdd.id = obj.id
					elemToAdd.label = obj.label
					elemToAdd.count = elem.displayStandTypeModelNumber
					elemToAdd.smallLockerNumbers = obj.smallLockers
					elemToAdd.mediumLockerNumbers = obj.mediumLockers
					elemToAdd.largeLockerNumbers = obj.largeLockers
					elemToAdd.extraLargeLockerNumbers = obj.extraLargeLockers
					notFoldedList.push(elemToAdd)
				}
			}
		})

		let foldedList = []
		extractData.displayStandTypes[1].displayStandModel.forEach((elem) => {
			let elemToAdd = {}
			if (elem.displayStandTypeModelNumber > 0) {
				const obj = find(selectedProfile.displayStandConfig, (o) => o.translationKey === elem.displayStandModel)
				if (!isUndefined(obj)) {
					elemToAdd.id = obj.id
					elemToAdd.label = obj.label
					elemToAdd.count = elem.displayStandTypeModelNumber
					elemToAdd.smallLockerNumbers = obj.foldedSmallLockers
					elemToAdd.mediumLockerNumbers = obj.foldedMediumLockers
					elemToAdd.largeLockerNumbers = obj.foldedLargeLockers
					elemToAdd.extraLargeLockerNumbers = obj.foldedExtraLargeLockers
					foldedList.push(elemToAdd)
				}
			}
		})

		let accessoriesList = []
		kioskCreationDefinition.data.displayStandInformation.forEach((elem) => {
			let elemToAdd = {}
			if (!isUndefined(elem.accessoryDisplayStand) && !isNull(elem.accessoryDisplayStand)) {
				const obj = find(selectedProfile.displayStandConfig, (o) => o.id === elem.idDisplayStandModel)
				if (!isUndefined(obj) && !isEmpty(elem.accessoryDisplayStand)) {
					const objAccNumb = find(obj.accessoryDisplayLockersNumber, (o) => o.id === elem.accessoryDisplayStand[0].idAccessoryLockersNumber)
					const hasAccessory = findIndex(accessoriesList, { id: elem.idAccessoryDisplayStandModel })
					if (hasAccessory === -1) {
						elemToAdd = {
							id: elem.idAccessoryDisplayStandModel,
							count: 1,
							label: translations[elem.accessoryDisplayStand[0].accessoryDisplayStandModelName],
							countRacks: parseInt(objAccNumb.label),
						}
						accessoriesList.push(elemToAdd)
					} else {
						accessoriesList[hasAccessory].count++
					}
				}
			}
		})

		return {
			foldedList: foldedList,
			notFoldedList: notFoldedList,
			smallLockerNumbers: extractData.smallLockerNumber,
			mediumLockerNumbers: extractData.mediumLockerNumber,
			largeLockerNumbers: extractData.largeLockerNumber,
			extraLargeLockerNumbers: extractData.extraLargeLockerNumber,
			accessoriesList: accessoriesList,
		}
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////
	useEffect(() => {
		// Also setting registered switches
		setValue('interiorCover', false)
		setValue('lateralPanel', false)
		setValue('pda', false)
		setValue('restrictedLocation', false)
		setValue('solidDoor', false)

		let pageSwitches = cloneDeep(currentPageSwitches)
		pageSwitches.interiorCover = false
		pageSwitches.lateralPanel = false
		pageSwitches.pda = false
		pageSwitches.restrictedLocation = false
		pageSwitches.solidDoor = false
		setCurrentPageSwitches(pageSwitches)

		return function cleanUp() {
			actionsInitKioskCreationDefinition.resetDataCreationBusiness()
		}
	}, [])

	const [authorized, setAuthorized] = useState(false)
	const [dataLoaded, setDataLoaded] = useState(false)

	useEffect(() => {
		if (!authorized && globalLoading.count === 0) {
			setAuthorized(true)
		}
	}, [globalLoading.count])

	useEffect(() => {
		if (authorized) {
			if (!isUndefined(match.params.id)) {
				actionsInitKioskCreationDefinition.getDefinitionBusiness(match.params.id)
				setIsUpdate(true)
			} else {
				actionsInitKioskCreationDefinition.getAvailableListsBusiness()
				setIsEditable(true)
			}
		}
	}, [authorized])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	// Check if owner contains only one store manger or one store
	// In this case, we are setting it in our store too, because no onChange will be triggered
	useEffect(() => {
		if (!isNull(currentOwner?.storesManager)) {
			currentOwner?.storesManager.length === 1 && handleStoreManagerChange(currentOwner?.storesManager[0].id)
		} else {
			setCurrentStoreManager()
		}
		if (!isNull(currentOwner?.stores)) {
			currentOwner?.stores.length === 1 && handleStoreChange(currentOwner?.stores[0].id)
		} else {
			setCurrentStore()
		}
		if (!isNull(currentOwner?.distributors)) {
			currentOwner?.distributors.length === 1 && handleDistributorChange(currentOwner?.distributors[0].id)
		} else {
			setCurrentDistributor()
		}
	}, [currentOwner])

	useEffect(() => {
		if (dateInstallStateDate.showModal) {
			setCurrentDateInstallStateDate(dateInstallStateDate)
		}
	}, [dateInstallShowModal])

	useEffect(() => {
		if (buyoutDateStateDate.showModal) {
			setCurrentBuyoutDateStateDate(buyoutDateStateDate)
		}
	}, [buyoutDateShowModal])

	useEffect(() => {
		if (dateDeliveryStateDate.showModal) {
			setCurrentDateDeliveryStateDate(dateDeliveryStateDate)
		}
	}, [dateDeliveryShowModal])

	useEffect(() => {
		// If our state hook is not undefined, we can process
		// otherwise the error message will be shown
		if (!isUndefined(currentDateInstall) /* && !isUndefined(getValues("kioskDateInstallation"))*/) {
			if (!isUndefined(currentDateInstall.date.startDate)) {
				setValue('kioskDateInstallation', `${moment(currentDateInstall.date.startDate).format('DD-MM-YYYY')}`)
				clearErrors('kioskDateInstallation')
				//setLimitDeliveryDate(moment(currentDateInstall.date.startDate).toDate())
			} else {
				// If field is not undefined, it means that his value has been set, so error message can be printed
				// We are not in page loading anymore
				if (!isUndefined(getValues('kioskDateInstallation'))) {
					setError('kioskDateInstallation', { type: 'required', message: translations['common__text__requiredField'] })
					setValue('kioskDateInstallation', '')
				}
			}
		}
	}, [currentDateInstall])
	useEffect(() => {
		// If our state hook is not undefined, we can process
		// otherwise the error message will be shown
		if (!isUndefined(currentBuyoutDate) /* && !isUndefined(getValues("buyoutDate"))*/) {
			if (!isUndefined(currentBuyoutDate?.date.startDate)) {
				setValue('buyoutDate', `${moment(currentBuyoutDate.date.startDate).format('DD-MM-YYYY')}`)
				clearErrors('buyoutDate')
			} else {
				// If field is not undefined, it means that his value has been set, so error message can be printed
				// We are not in page loading anymore
				if (!isUndefined(getValues('kioskDateInstallation'))) {
					setError('buyoutDate', { type: 'required', message: translations['common__text__requiredField'] })
					setValue('buyoutDate', '')
				}
			}
		}
	}, [currentBuyoutDate])

	useEffect(() => {
		// If our state hook is not undefined, we can process
		// otherwise the error message will be shown
		if (!isUndefined(currentDateDelivery) /* && !isUndefined(getValues("kioskDateDelivery"))*/) {
			if (!isUndefined(currentDateDelivery?.date.startDate)) {
				setValue('kioskDateDelivery', `${moment(currentDateDelivery.date.startDate).format('DD-MM-YYYY')}`)
				clearErrors('kioskDateDelivery')
				//setLimitInstallDate(moment(currentDateDelivery.date.startDate).toDate())
			} else {
				// If field is not undefined, it means that his value has been set, so error message can be printed
				// We are not in page loading anymore
				if (!isUndefined(getValues('kioskDateDelivery'))) {
					setError('kioskDateDelivery', { type: 'required', message: translations['common__text__requiredField'] })
					setValue('kioskDateDelivery', '')
				}
			}
		}
	}, [currentDateDelivery])

	// When page config is updated
	useEffect(() => {
		if (!isUndefined(kioskCreationDefinitionOptions.listProfiles) && !isEqual(kioskCreationDefinitionOptions.listProfiles, [])) {
			setListProfiles(kioskCreationDefinitionOptions.listProfiles)
		}

		if (!isUndefined(kioskCreationDefinitionOptions.selectedProfile) && !isEqual(kioskCreationDefinitionOptions.selectedProfile, {})) {
			setAvailableRackList(kioskCreationDefinitionOptions.selectedProfile.displayStandConfig)
			setSelectedProfile(kioskCreationDefinitionOptions.selectedProfile)
		}
	}, [kioskCreationDefinitionOptions])

	// When selected profile is updated, registering switch fields
	useEffect(() => {
		if (!isUndefined(selectedProfile) && !isEqual(selectedProfile, {})) {
			setValue('kioskOwnerConfig', selectedProfile.id)
			setValue('barCodeReader', selectedProfile.barCodeReader)
			setValue('bottleDetectionAvailable', selectedProfile.bottleDetectionAvailable)
			setValue('bottleMatterSensor', selectedProfile.bottleMatterSensor)
			//setValue("bottleTopSensor",selectedProfile.bottleTopSensor)
			setValue('codePaymentAvailable', selectedProfile.codePaymentAvailable)
			//setValue("energyCard",selectedProfile.energyCard)

			setValue('marker', selectedProfile.marker)

			setValue('platineSet', selectedProfile.platineSet)
			setValue('printerAvailable', selectedProfile.printerAvailable)

			setValue('scaleAvailable', selectedProfile.scaleAvailable)
			setValue('solarPanelAvailable', selectedProfile.solarPanelAvailable)

			setValue('ticketByMailAvailable', selectedProfile.ticketByMailAvailable)
			setValue('tpaAvailable', selectedProfile.tpaAvailable)
		}
	}, [selectedProfile])
	useEffect(() => {
		register(
			{ name: 'kioskDateInstallation' },
			{
				required: {
					value: true,
					message: translations['common__text__requiredField'],
				},
			}
		)
		register(
			{ name: 'buyoutDate' },
			{
				required: {
					value: false,
					message: translations['common__text__requiredField'],
				},
			}
		)
		register(
			{ name: 'kioskDateDelivery' },
			{
				required: {
					value: false,
					message: translations['common__text__requiredField'],
				},
			}
		)
	}, [register, translations])

	useEffect(() => {
		if (isUpdate) {
			setValue('quantity', kioskCreationDefinition.data.quantity)
		}
	}, [kioskCreationDefinition.data?.quantity, stockRequestCheck])

	// On data loaded
	useEffect(() => {
		if (!isEqual(kioskCreationDefinition.data, {}) && isUpdate && isUndefined(currentOwner) && !isEqual(selectedProfile, {}) && !dataLoaded) {
			let valueSelect
			setStockRequestCheck(kioskCreationDefinition.data.stockRequest)

			if (!isUndefined(kioskCreationDefinition?.data?.progressInfo?.subFlow)) {
				const f = find(kioskBusinessRequestStatusPicsConfig, { subFlow: kioskCreationDefinition?.data?.progressInfo?.subFlow })
				!isUndefined(f) && setRequestStatusPict(f.picture)
			}
			setRequestStatusPict()
			setValue('stockRequest', kioskCreationDefinition.data.stockRequest)
			//setValue("quantity",kioskCreationDefinition.data.quantity)
			setValue('requestName', kioskCreationDefinition.data.requestName)

			setValue('contactLastName', kioskCreationDefinition.data.contactInformation.contactLastName)
			setValue('contactFirstName', kioskCreationDefinition.data.contactInformation.contactFirstName)
			setValue('contactEmail', kioskCreationDefinition.data.contactInformation.contactEmail)
			!isNull(kioskCreationDefinition.data.contactInformation.contactPhoneNumber) &&
				setValue('contactPhoneNumber', kioskCreationDefinition.data.contactInformation.contactPhoneNumber)

			//userCreatedKioskInfo
			setValue('kioskLabelToOwner', kioskCreationDefinition.data.kioskInformation.kioskLabelToOwner)
			setValue('kioskDescription', kioskCreationDefinition.data.kioskInformation.kioskDescription)
			setValue('welcomeMessage', kioskCreationDefinition.data.kioskInformation.welcomeMessage)
			setValue('bottleDetectionAvailable', kioskCreationDefinition.data.kioskInformation.bottleDetectionAvailable)
			setValue('codePaymentAvailable', kioskCreationDefinition.data.kioskInformation.codePaymentAvailable)
			setValue('tpaAvailable', kioskCreationDefinition.data.kioskInformation.tpaAvailable)
			setValue('scaleAvailable', kioskCreationDefinition.data.kioskInformation.scaleAvailable)
			setValue('printerAvailable', kioskCreationDefinition.data.kioskInformation.printerAvailable)
			setValue('ticketByMailAvailable', kioskCreationDefinition.data.kioskInformation.ticketByMailAvailable)
			setValue('solarPanelAvailable', kioskCreationDefinition.data.kioskInformation.solarPanelAvailable)
			setValue('bottleMatterSensor', kioskCreationDefinition.data.kioskInformation.bottleMatterSensor)
			//setValue("energyCard",kioskCreationDefinition.data.kioskInformation.energyCard)
			setValue('pda', kioskCreationDefinition.data.kioskInformation.pda)
			setValue('solidDoor', kioskCreationDefinition.data.kioskInformation.solidDoor)
			setValue('lateralPanel', kioskCreationDefinition.data.kioskInformation.lateralPanel)
			setValue('interiorCover', kioskCreationDefinition.data.kioskInformation.interiorCover)
			setValue('restrictedLocation', kioskCreationDefinition.data.kioskInformation.restrictedLocation)
			setValue('platineSet', kioskCreationDefinition.data.kioskInformation.platineSet)
			setValue('marker', kioskCreationDefinition.data.kioskInformation.marker)
			setValue('barCodeReader', kioskCreationDefinition.data.kioskInformation.barCodeReader)

			let pageSwitches = cloneDeep(currentPageSwitches)
			pageSwitches.interiorCover = kioskCreationDefinition.data.kioskInformation.interiorCover
			pageSwitches.lateralPanel = kioskCreationDefinition.data.kioskInformation.lateralPanel
			pageSwitches.pda = kioskCreationDefinition.data.kioskInformation.pda
			pageSwitches.restrictedLocation = kioskCreationDefinition.data.kioskInformation.restrictedLocation
			pageSwitches.solidDoor = kioskCreationDefinition.data.kioskInformation.solidDoor
			setCurrentPageSwitches(pageSwitches)

			if (kioskCreationDefinition.data.stockRequest) {
				unregister(['installationType', 'kioskDateInstallation', 'kioskDateDelivery', 'kioskLanguage', 'reseller', 'store', 'storeManager'])
			} else {
				valueSelect = find(kioskCreationDefinition.data.installationTypes, (o) => o.selected === true)
				!isUndefined(valueSelect) && setValue('installationType', valueSelect.id)

				if (!isNull(kioskCreationDefinition.data.kioskInformation.kioskDateInstallation)) {
					setValue(
						'kioskDateInstallation',
						moment(kioskCreationDefinition.data.kioskInformation.kioskDateInstallation).format('DD/MM/YYYY')
					)
					currentDateInstall.date.startDate = moment(kioskCreationDefinition.data.kioskInformation.kioskDateInstallation).toDate()
					dateInstallStartDate(moment(kioskCreationDefinition.data.kioskInformation.kioskDateInstallation).toDate())
					setLimitDeliveryDate(moment(kioskCreationDefinition.data.kioskInformation.kioskDateInstallation).toDate())
				}

				if (!isNull(kioskCreationDefinition.data.kioskInformation.kioskDateDelivery)) {
					setValue('kioskDateDelivery', moment(kioskCreationDefinition.data.kioskInformation.kioskDateDelivery).format('DD/MM/YYYY'))
					currentDateDelivery.date.startDate = moment(kioskCreationDefinition.data.kioskInformation.kioskDateDelivery).toDate()
					dateDeliveryStartDate(moment(kioskCreationDefinition.data.kioskInformation.kioskDateDelivery).toDate())
					setLimitInstallDate(moment(kioskCreationDefinition.data.kioskInformation.kioskDateDelivery).toDate())
				}
			}

			valueSelect = find(kioskCreationDefinition.data.availableLanguages, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('kioskLanguage', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.owner, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('owner', valueSelect.id)
			setCurrentOwner(valueSelect)

			valueSelect = find(kioskCreationDefinition.data.manufacturer, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('manufacturer', valueSelect.id)
			setCurrentManufacturer(valueSelect)

			valueSelect = find(kioskCreationDefinition.data.reseller, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('reseller', valueSelect.id)
			setCurrentReseller(valueSelect)

			valueSelect = find(kioskCreationDefinition.data.kioskModels, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('kioskModel', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.kioskOwnerConfigs, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('kioskOwnerConfig', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.warranty, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('kioskWarranty', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.tpaModel, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('tpaModel', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.integrator, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('integrator', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.connectivity, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('kioskConnectivity', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.salesmen, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('userSeller', valueSelect.id)

			if (!isNull(kioskCreationDefinition.data.dateBuyout)) {
				setValue('buyoutDate', moment(kioskCreationDefinition.data.dateBuyout).format('DD/MM/YYYY'))
				currentBuyoutDate.date.startDate = moment(kioskCreationDefinition.data.dateBuyout).toDate()
				buyoutDateStartDate(moment(kioskCreationDefinition.data.dateBuyout).toDate())
			}

			if (!isEqual(selectedProfile, {})) {
				setValue('noteProduction', kioskCreationDefinition.data.kioskInformation.noteProduction)
				setValue('noteCommercial', kioskCreationDefinition.data.kioskInformation.noteCommercial)
				//}else{
				// If we got customer informations
				let customerInformations = null

				if (!isNull(kioskCreationDefinition.data.customerDisplayStandInformation.displayStandNumber)) {
					customerInformations = extractRacksInformations()
					setRecapRackCustomer(customerInformations)
				}

				if (isNull(kioskCreationDefinition.data.manufacturerDisplayStandInformation.displayStandNumber)) {
					!isNull(customerInformations) && setRecapRack(extractRacksInformations())
				} else {
					setRecapRack(extractRacksInformations('manufacturer'))
				}
				//}
				setAddedRackList(kioskCreationDefinition.data.displayStandInformation)
			}

			// If customer has validated, we need to lock some fields
			setCustomerValidated(kioskCreationDefinition.data?.validation.customerValidated)

			// Disable fields if we are coming from "View" action, or by charging request with URL address
			let editable = true
			if (kioskCreation.forceReadOnly) {
				editable = false
			} else {
				editable = kioskCreationDefinition.data.progressInfo.editable
			}
			setIsEditable(editable)

			setDataLoaded(true)
		}
	}, [kioskCreationDefinition.data, stockRequestCheck, selectedProfile, dataLoaded, customerValidated])

	// When company is created
	useEffect(() => {
		// Also refreshing list when company is created (by company "manager" modal)
		// Only refreshing data when we are in a created kiosk request (with an ID in URL)
		//if(updatedCompany /*&& !isUndefined(match.params.id)*/)
		if (updatedCompany) {
			!isUndefined(match.params.id)
				? actionsInitKioskCreationDefinition.refreshDefinitionBusiness(match.params.id)
				: actionsInitKioskCreationDefinition.getAvailableListsBusiness()
		}
	}, [updatedCompany])
	useEffect(() => {
		if (!isUndefined(kioskCreationDefinition.availableOptions.owner) && !isUndefined(currentOwner)) {
			let c = cloneDeep(currentOwner)
			const f = find(kioskCreationDefinition.availableOptions.owner, (o) => o.id === c.id)
			if (!isUndefined(f) && !isNull(kioskCreationDefinition.idCompanyCreated)) {
				c = f

				c.stores = map(c.stores, (elem) => {
					if (elem.details.companyName === kioskCreationDefinition.rsCompanyCreated) elem.selected = true
					return elem
				})
				//setValue("store",c.id)
				setValue('store', kioskCreationDefinition.idCompanyCreated)
			}
			setCurrentOwner(c)
		}
	}, [kioskCreationDefinition.availableOptions.owner])

	// flag for allowed to set value on field on 2nd cycle according  to status
	useEffect(() => {
		if (
			kioskCreationDefinition.data.progressInfo?.fromStock &&
			(kioskCreationDefinition.data.progressInfo?.statusId < 11 || kioskCreationDefinition.data.progressInfo?.statusId === 19)
		) {
			setIsEditableSecondCycle(true)
		}
	}, [kioskCreationDefinition.data.progressInfo?.fromStock, kioskCreationDefinition.data.progressInfo?.statusId])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			{dateInstallRenderModal()}
			{buyoutDateRenderModal()}
			{dateDeliveryRenderModal()}
			<Modals closeModalHandler={handleCloseModals} showModal={showModalCompanyCreate} minWidth={1200}>
				<CompanyDetail kioskCreationMode={true} noDataPassed={false} closeModalHandler={handleCloseModals} />
			</Modals>
			{/*MODAL MAINTAINER  */}

			<Modals
				title={translations['page_admin_initKiosk_stepOne_sheet_linkTo_maintainerDetails']}
				showModal={showModalMaintainerDetail}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					<TextModalList>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_company_name']} :</LabelText>
						<span>{currentMaintainer?.details?.companyName}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_siret']} :</LabelText>
						<span>{currentMaintainer?.details?.siret}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_address']} :</LabelText>
						<span>{currentMaintainer?.details?.address}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_postalCode']} :</LabelText>
						<span>{currentMaintainer?.details?.postalCode}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_city']} :</LabelText>
						<span>{currentMaintainer?.details?.city}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_country']} :</LabelText>
						<span>{currentMaintainer?.details?.country}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_divisions']} :</LabelText>
						<span>
							{map(currentMaintainer?.details?.companyDivisions, (elem, id) => {
								return `${id > 0 ? ', ' : ''}${translations[elem]}`
							})}
						</span>
					</TextModalList>
				</TextModalWrapper>
			</Modals>

			<Modals closeModalHandler={handleCloseModals} showModal={showModalCompaniesManager} minWidth={1200}>
				<CompanyDetail kioskCreationMode={true} noDataPassed={true} closeModalHandler={handleCloseModals} />
			</Modals>
			<Modals
				title={translations['page_admin_initKiosk_stepOne_sheet_linkTo_manufacturerDetails']}
				showModal={showModalManufacturerDetail}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					<TextModalList>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_company_name']} :</LabelText>
						<span>{currentManufacturer?.details?.companyName}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_siret']} :</LabelText>
						<span>{currentManufacturer?.details?.siret}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_address']} :</LabelText>
						<span>{currentManufacturer?.details?.address}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_postalCode']} :</LabelText>
						<span>{currentManufacturer?.details?.postalCode}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_city']} :</LabelText>
						<span>{currentManufacturer?.details?.city}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_country']} :</LabelText>
						<span>{currentManufacturer?.details?.country}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_divisions']} :</LabelText>
						<span>
							{map(currentManufacturer?.details?.companyDivisions, (elem, id) => {
								return `${id > 0 ? ', ' : ''}${translations[elem]}`
							})}
						</span>
					</TextModalList>
				</TextModalWrapper>
			</Modals>
			<Modals
				title={translations['page_admin_initKiosk_stepOne_sheet_linkTo_ownerDetails']}
				showModal={showModalOwnerDetail}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					<TextModalList>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_company_name']} :</LabelText>
						<span>{currentOwner?.details?.companyName}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_siret']} :</LabelText>
						<span>{currentOwner?.details?.siret}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_address']} :</LabelText>
						<span>{currentOwner?.details?.address}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_postalCode']} :</LabelText>
						<span>{currentOwner?.details?.postalCode}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_city']} :</LabelText>
						<span>{currentOwner?.details?.city}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_country']} :</LabelText>
						<span>{currentOwner?.details?.country}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_divisions']} :</LabelText>
						<span>
							{map(currentOwner?.details?.companyDivisions, (elem, id) => {
								return `${id > 0 ? ', ' : ''}${translations[elem]}`
							})}
						</span>
					</TextModalList>
				</TextModalWrapper>
			</Modals>
			<Modals
				title={translations['page_admin_initKiosk_stepOne_sheet_linkTo_storeManagerDetails']}
				showModal={showModalStoreManagerDetail}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					<TextModalList>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_company_name']} :</LabelText>
						<span>{currentStoreManager?.details?.companyName}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_siret']} :</LabelText>
						<span>{currentStoreManager?.details?.siret}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_address']} :</LabelText>
						<span>{currentStoreManager?.details?.address}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_postalCode']} :</LabelText>
						<span>{currentStoreManager?.details?.postalCode}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_city']} :</LabelText>
						<span>{currentStoreManager?.details?.city}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_country']} :</LabelText>
						<span>{currentStoreManager?.details?.country}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_divisions']} :</LabelText>
						<span>
							{map(currentStoreManager?.details?.companyDivisions, (elem, id) => {
								return `${id > 0 ? ', ' : ''}${translations[elem]}`
							})}
						</span>
					</TextModalList>
				</TextModalWrapper>
			</Modals>
			<Modals
				title={translations['page_admin_initKiosk_stepOne_sheet_linkTo_storeDetails']}
				showModal={showModalStoreDetail}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					<TextModalList>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_company_name']} :</LabelText>
						<span>{currentStore?.details?.companyName}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_siret']} :</LabelText>
						<span>{currentStore?.details?.siret}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_address']} :</LabelText>
						<span>{currentStore?.details?.address}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_postalCode']} :</LabelText>
						<span>{currentStore?.details?.postalCode}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_city']} :</LabelText>
						<span>{currentStore?.details?.city}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_country']} :</LabelText>
						<span>{currentStore?.details?.country}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_divisions']} :</LabelText>
						<span>
							{map(currentStore?.details?.companyDivisions, (elem, id) => {
								return `${id > 0 ? ', ' : ''}${translations[elem]}`
							})}
						</span>
					</TextModalList>
				</TextModalWrapper>
			</Modals>
			<Modals
				title={translations['page_admin_initKiosk_stepOne_sheet_linkTo_distributorDetails']}
				showModal={showModalDistributorDetail}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					<TextModalList>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_company_name']} :</LabelText>
						<span>{currentDistributor?.details?.companyName}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_siret']} :</LabelText>
						<span>{currentDistributor?.details?.siret}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_address']} :</LabelText>
						<span>{currentDistributor?.details?.address}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_postalCode']} :</LabelText>
						<span>{currentDistributor?.details?.postalCode}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_city']} :</LabelText>
						<span>{currentDistributor?.details?.city}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_country']} :</LabelText>
						<span>{currentDistributor?.details?.country}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_divisions']} :</LabelText>
						<span>
							{map(currentDistributor?.details?.companyDivisions, (elem, id) => {
								return `${id > 0 ? ', ' : ''}${translations[elem]}`
							})}
						</span>
					</TextModalList>
				</TextModalWrapper>
			</Modals>
			<Modals
				title={translations['page_admin_initKiosk_stepOne_sheet_linkTo_resellerDetails']}
				showModal={showModalResellerDetail}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					<TextModalList>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_company_name']} :</LabelText>
						<span>{currentReseller?.details?.companyName}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_siret']} :</LabelText>
						<span>{currentReseller?.details?.siret}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_address']} :</LabelText>
						<span>{currentReseller?.details?.address}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_postalCode']} :</LabelText>
						<span>{currentReseller?.details?.postalCode}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_city']} :</LabelText>
						<span>{currentReseller?.details?.city}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_country']} :</LabelText>
						<span>{currentReseller?.details?.country}</span>
						<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_divisions']} :</LabelText>
						<span>
							{map(currentReseller?.details?.companyDivisions, (elem, id) => {
								return `${id > 0 ? ', ' : ''}${translations[elem]}`
							})}
						</span>
					</TextModalList>
				</TextModalWrapper>
			</Modals>
			<KioskCreationDefinitionBusinessWrapper>
				<PageWrapperLinksCustom rafterDisplayed={kioskCreation.statusId >= 6 ? true : false}>
					<Button goBack weight="bold" actionHandler={() => handleRedirect()} text={translations['common__text__previousPage']} />
				</PageWrapperLinksCustom>
				<form onSubmit={handleSubmit(onSubmitKiosk)}>
					<LineTableHeader>
						<PageTitle>{translations['page_admin_initKiosk_stepOne_title']}</PageTitle>
						<PageWrapperActions>
							{user?.identity?.company?.companyTyped.idCompanyType !== 10 ? (
								<Button
									weight="bold"
									actionHandler={() => handleSubmit(onSubmitKiosk)}
									text={translations['page_admin_initKiosk_stepOne_button_generateQuote']}
									id={'ActionGenerateQuote'}
									bgColor={Theme.colors.validation}
									img={Validation}
									width={208}
									imgMgin={'16px'}
									noHash
									mgLeft={'5px'}
									disabled={(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)}
								/>
							) : (
								<Button
									weight="bold"
									actionHandler={() => handleSubmit(onSubmitKiosk)}
									text={translations['page_admin_initKiosk_stepOne_button_send']}
									id={'ActionCreate'}
									bgColor={Theme.colors.validation}
									img={Validation}
									width={191}
									imgMgin={'16px'}
									noHash
									mgLeft={'5px'}
									disabled={!isEditable}
								/>
							)}
							<Tooltip tooltipId={'kioskCreationDefinitionBusinessCancel'} translationsKey={'tooltip_admin_initKiosk_stepOne_close'}>
								<PageWrapperActionPrevPage onClick={() => history.push(`${uriList.initKiosks}${uriList.initKioskBusinessManager}`)} />
							</Tooltip>
							{/*<Tooltip
							tooltipId={ "kioskCreationDefinitionBusinessSave" }
							translationsKey={ "tooltip_admin_initKiosk_stepOne_save" }
						>
							<PageWrapperActionSave type="submit" id={"ActionSave"} disabled={!isEditable}/>
						</Tooltip>*/}
						</PageWrapperActions>
					</LineTableHeader>
					<PageWrapperGridsCustom grids={4}>
						<KioskCreationDefinitionBusinessColumn>
							<KioskCreationDefinitionBusinessPart>
								<KioskCreationDefinitionBusinessTitlePart>
									{translations['page_admin_initKiosk_stepOne_sheet_requestInformation']}
								</KioskCreationDefinitionBusinessTitlePart>
								<KioskCreationDefinitionBusinessContentPart>
									<KioskCreationDefinitionBusinessStatus>
										{!isUndefined(kioskCreationDefinition.data?.requestStatus) && !isUndefined(findSubFlow) ? (
											<Fragment>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_status']} :</LabelText>
												<img src={findSubFlow.picture} />
												<SpanTitle style={{ marginLeft: '5px' }}>
													{!isUndefined(translations[kioskCreationDefinition.data?.requestStatus.translationKey]) &&
														translations[kioskCreationDefinition.data?.requestStatus.translationKey]}
												</SpanTitle>
											</Fragment>
										) : (
											<Fragment>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_status']} :</LabelText>
												<SpanTitle style={{ marginLeft: '5px' }}>
													{!isUndefined(translations[kioskCreationDefinition.data?.requestStatus?.translationKey]) &&
														translations[kioskCreationDefinition.data?.requestStatus?.translationKey]}
												</SpanTitle>
											</Fragment>
										)}
									</KioskCreationDefinitionBusinessStatus>
									<KioskCreationDefinitionBusinessStockRequest>
										<div>
											<input
												type="checkbox"
												name="stockRequest"
												disabled={!isEditable || !isEqual(match.params, {})}
												checked={stockRequestCheck}
												ref={register({})}
												onClick={() => (customerValidated ? false : handleStockRequestCheck())}
											/>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_isStock']}</LabelText>
										</div>
										{stockRequestCheck && (
											<KioskCreationDefinitionBusinessStockRequestQuantity>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_quantity']} :</LabelText>
												<InputWrapper>
													<InputLogin
														type="text"
														name="quantity"
														disabled={!isEditable || !isEqual(match.params, {})}
														readOnly={customerValidated}
														placeholder={translations['page_admin_initKiosk_stepOne_sheet_quantity_placeholder']}
														ref={register({
															/*pattern: {
															value: /(?<=\s|^)\d+(?=\s|$)/,
															message:translations['common__text__positiveInteger']
														},*/
															//validate: value => ((stockRequestCheck && isNumber(parseInt(value)) && (parseInt(value) > 0 && parseInt(value) < 100) && value.length > 0) || !stockRequestCheck) || translations['common__text__requiredField']
															validate: (value) => {
																const v = parseInt(value)
																if (stockRequestCheck) {
																	if (value.length > 0) {
																		if (isNumber(v) && !isNaN(v)) {
																			if (v > 0 && v <= 10) {
																				return true
																			} else {
																				return StringFormatter.ResponseMessageParser(
																					translations['common__text__integerBetween'],
																					['0', '10']
																				)
																			}
																		} else {
																			return translations['common__text__positiveInteger']
																		}
																	} else {
																		return translations['common__text__requiredField']
																	}
																} else {
																	return true
																}
															},
														})}
													/>
													{errors.quantity && <ErrorInputMsg>{errors.quantity.message}</ErrorInputMsg>}
												</InputWrapper>
											</KioskCreationDefinitionBusinessStockRequestQuantity>
										)}
									</KioskCreationDefinitionBusinessStockRequest>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_salesman']} :</LabelText>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="userSeller"
												disabled={!isEditable}
												ref={register({
													required: {
														value: false, //!stockRequestCheck,
														message: translations['common__text__requiredField'],
													},
													//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
												})}
												className={watch('userSeller') > 0 ? 'active' : ''}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_salesman_placeholder']}
												</OptionCustom>
												{map(kioskCreationDefinitionOptions.salesmen, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} selected={elem.selected}>
															{elem.fullName}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.userSeller && <ErrorInputMsg>{errors.userSeller.message}</ErrorInputMsg>}
									</div>
									<div>
										<LabelTextCustom>{translations['page_admin_initKiosk_stepOne_sheet_requestName']} :</LabelTextCustom>
										<InputWrapper>
											<InputLogin
												type="text"
												name="requestName"
												readOnly={customerValidated && !isEditableSecondCycle}
												disabled={!isEditable}
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_requestName_placeholder']}
												ref={register({
													maxLength: {
														value: 100,
														message: `100 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
												})}
											/>
											{errors.requestName && <ErrorInputMsg>{errors.requestName.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
									<BuyoutDateHandler>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_buyoutDate']} :</LabelText>
										<CalendarInputInline
											name="buyoutDate"
											disabled={!isEditable}
											onClickHandler={buyoutDateOpenDateModalHandler}
											valueInput={
												!isUndefined(currentBuyoutDate.date.startDate)
													? `${moment(currentBuyoutDate.date.startDate).format('DD/MM/YYYY')}`
													: ''
											}
										/>
										{errors.buyoutDate && <ErrorInputMsg>{errors.buyoutDate.message}</ErrorInputMsg>}
									</BuyoutDateHandler>
								</KioskCreationDefinitionBusinessContentPart>
							</KioskCreationDefinitionBusinessPart>
							<KioskCreationDefinitionBusinessPart>
								<KioskCreationDefinitionBusinessTitlePart>
									{translations['page_admin_initKiosk_stepOne_sheet_companyInformation']}
								</KioskCreationDefinitionBusinessTitlePart>
								<KioskCreationDefinitionBusinessContentPart>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_manufacturer']}* :</LabelText>
										<SelectInputDetailHandler>
											<SelectInputWrapper>
												<SelectInputCustom
													width="208"
													name="manufacturer"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													ref={register({
														required: {
															value: true,
															message: translations['common__text__requiredField'],
														},
														validate: (value) => value > 0 || translations['common__text__requiredField'],
													})}
													className={watch('manufacturer') > 0 ? 'active' : ''}
													onChange={(e) => handleManufacturerChange(e.target.value)}
												>
													<OptionCustom value="0" hidden>
														{translations['page_admin_initKiosk_stepOne_sheet_manufacturer_placeholder']}
													</OptionCustom>
													{map(kioskCreationDefinitionOptions.manufacturer, (elem, id) => {
														return (
															<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																{elem.details.companyName}
															</OptionCustom>
														)
													})}
												</SelectInputCustom>
												{!isUndefined(currentManufacturer) && (
													<a onClick={() => handleOpenModals({}, 'handleModalManufacturer')}>
														{translations['page_admin_initKiosk_stepOne_sheet_linkTo_viewDetails']}
													</a>
												)}
											</SelectInputWrapper>
											{errors.manufacturer && <ErrorInputMsg>{errors.manufacturer.message}</ErrorInputMsg>}
										</SelectInputDetailHandler>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_owner']}* :</LabelText>
										<SelectInputDetailHandler>
											<SelectInputWrapper>
												<SelectInputCustom
													width="208"
													name="owner"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													ref={register({
														required: {
															value: true /*!stockRequestCheck*/,
															message: translations['common__text__requiredField'],
														},
														validate: (value) =>
															/*((*/ value > 0 /* && !stockRequestCheck) || stockRequestCheck)*/ ||
															translations['common__text__requiredField'],
													})}
													className={watch('owner') > 0 ? 'active' : ''}
													onChange={(e) => handleOwnerChange(e.target.value)}
												>
													<OptionCustom value="0" hidden>
														{translations['page_admin_initKiosk_stepOne_sheet_owner_placeholder']}
													</OptionCustom>
													{map(kioskCreationDefinitionOptions.owner, (elem, id) => {
														return (
															<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																{elem.details.companyName}
															</OptionCustom>
														)
													})}
												</SelectInputCustom>
												{!isUndefined(currentOwner) && (
													<a onClick={() => handleOpenModals({}, 'handleModalOwner')}>
														{translations['page_admin_initKiosk_stepOne_sheet_linkTo_viewDetails']}
													</a>
												)}
											</SelectInputWrapper>
											{errors.owner && <ErrorInputMsg>{errors.owner.message}</ErrorInputMsg>}
										</SelectInputDetailHandler>
									</div>
									{!stockRequestCheck && (
										<div>
											<SelectInputDetailHandler>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_storeManager']} :</LabelText>
												<SelectInputWrapper>
													<SelectInputCustom
														width="208"
														name="storeManager"
														disabled={
															(!isEditable && !isEditableSecondCycle) ||
															(kioskCreation.forceReadOnly && isEditableSecondCycle)
														}
														ref={register({
															required: {
																value: false /*!stockRequestCheck*/,
																message: translations['common__text__requiredField'],
															},
															//validate:value => /*((*/value > 0/* && !stockRequestCheck) || stockRequestCheck)*/ || translations['common__text__requiredField']
														})}
														className={watch('storeManager') > 0 ? 'active' : ''}
														onChange={(e) => handleStoreManagerChange(e.target.value)}
													>
														<OptionCustom value="0" hidden>
															{translations['page_admin_initKiosk_stepOne_sheet_storeManager_placeholder']}
														</OptionCustom>
														{!isUndefined(currentOwner) &&
															map(currentOwner?.storesManager, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																		{elem.details.companyName}
																	</OptionCustom>
																)
															})}
													</SelectInputCustom>
													{!isUndefined(currentStoreManager) && (
														<a onClick={() => handleOpenModals({}, 'handleModalStoreManager')}>
															{translations['page_admin_initKiosk_stepOne_sheet_linkTo_viewDetails']}
														</a>
													)}
												</SelectInputWrapper>
												{errors.storeManager && <ErrorInputMsg>{errors.storeManager.message}</ErrorInputMsg>}
											</SelectInputDetailHandler>
										</div>
									)}
								</KioskCreationDefinitionBusinessContentPart>
								{customerValidated && !stockRequestCheck && (
									<KioskCreationDefinitionBusinessInfo>
										<div>
											<span>{translations['page_admin_initKiosk_stepOne_sheet_userRequestStoreInformation']}</span>
											<Tooltip
												tooltipId={'kioskCreationDefinitionCustomerDisplayStoreInfo'}
												translationsKey={
													showStoreInfo ? 'tooltip_admin_initKiosk_stepOne_hide' : 'tooltip_admin_initKiosk_stepOne_display'
												}
											>
												<img
													src={showStoreInfo ? CloseEyeIcon : OpenEyeIcon}
													onClick={() => setShowStoreInfo(!showStoreInfo)}
												/>
											</Tooltip>
										</div>
										{showStoreInfo && (
											<KioskCreationDefinitionBusinessInfoPart>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_company_name']} :</LabelText>
												<span>{kioskCreationDefinition.data.userCreatedStoreInfo.storeLabelCommercial}</span>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_storeType']} :</LabelText>
												<span>{translations[kioskCreationDefinition.data.userCreatedStoreInfo.storeType]}</span>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_address']} :</LabelText>
												<span>{kioskCreationDefinition.data.userCreatedStoreInfo.storeAddress}</span>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_postalCode']} :</LabelText>
												<span>{kioskCreationDefinition.data.userCreatedStoreInfo.storePostalCode}</span>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_city']} :</LabelText>
												<span>{kioskCreationDefinition.data.userCreatedStoreInfo.storeCity}</span>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_country']} :</LabelText>
												<span>{kioskCreationDefinition.data.userCreatedStoreInfo.country}</span>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_siret']} :</LabelText>
												<span>{kioskCreationDefinition.data.userCreatedStoreInfo.storeSiret}</span>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_company_phone']} :</LabelText>
												<span>{kioskCreationDefinition.data.userCreatedStoreInfo.storePhoneNumber}</span>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_company_email']} :</LabelText>
												<span>{kioskCreationDefinition.data.userCreatedStoreInfo.storeEmail}</span>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_smsSend']} :</LabelText>
												<input
													type="checkbox"
													checked={kioskCreationDefinition.data.userCreatedStoreInfo.smsAvailable}
													disabled
												/>
												{!isUndefined(
													find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[14])
												) && (
													<div style={{ width: '208px' }}>
														<Link
															onClick={() => isEditable && setShowModalCompanyCreate(true)}
															style={{ textDecoration: 'none' }}
														>
															<Button
																weight="bold"
																text={translations['page_admin_initKiosk_stepOne_button_storeCreate']}
																disabled={!isEditable}
																height={32}
															/>
														</Link>
													</div>
												)}
											</KioskCreationDefinitionBusinessInfoPart>
										)}
									</KioskCreationDefinitionBusinessInfo>
								)}
								<KioskCreationDefinitionBusinessContentPart>
									{!stockRequestCheck && (
										<div>
											<SelectInputDetailHandler>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store']}* :</LabelText>
												<SelectInputWrapper>
													<SelectInputCustom
														width="208"
														name="store"
														disabled={
															(!isEditable && !isEditableSecondCycle) ||
															(kioskCreation.forceReadOnly && isEditableSecondCycle)
														}
														ref={register({
															required: {
																value: true,
																message: translations['common__text__requiredField'],
															},
															validate: (value) => value > 0 || translations['common__text__requiredField'],
														})}
														className={watch('store') > 0 ? 'active' : ''}
														onChange={(e) => handleStoreChange(e.target.value)}
													>
														<OptionCustom value="0" hidden>
															{translations['page_admin_initKiosk_stepOne_sheet_store_placeholder']}
														</OptionCustom>
														{!isUndefined(currentOwner) &&
															map(currentOwner?.stores, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																		{elem.details.companyName}
																	</OptionCustom>
																)
															})}
													</SelectInputCustom>
													{!isUndefined(currentStore) && (
														<a onClick={() => handleOpenModals({}, 'handleModalStore')}>
															{translations['page_admin_initKiosk_stepOne_sheet_linkTo_viewDetails']}
														</a>
													)}
												</SelectInputWrapper>
												{errors.store && <ErrorInputMsg>{errors.store.message}</ErrorInputMsg>}
											</SelectInputDetailHandler>
										</div>
									)}
									<div>
										<SelectInputDetailHandler>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_distributor']}* :</LabelText>
											<SelectInputWrapper>
												<SelectInputCustom
													width="208"
													name="distributor"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													ref={register({
														required: {
															value: true,
															message: translations['common__text__requiredField'],
														},
														validate: (value) => value > 0 || translations['common__text__requiredField'],
													})}
													className={watch('distributor') > 0 ? 'active' : ''}
													onChange={(e) => handleDistributorChange(e.target.value)}
												>
													<OptionCustom value="0" hidden>
														{translations['page_admin_initKiosk_stepOne_sheet_distributor_placeholder']}
													</OptionCustom>
													{!isUndefined(currentOwner) &&
														map(currentOwner?.distributors, (elem, id) => {
															return (
																<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																	{elem.details.companyName}
																</OptionCustom>
															)
														})}
												</SelectInputCustom>
												{!isUndefined(currentDistributor) && (
													<a onClick={() => handleOpenModals({}, 'handleModalDistributor')}>
														{translations['page_admin_initKiosk_stepOne_sheet_linkTo_viewDetails']}
													</a>
												)}
											</SelectInputWrapper>
											{errors.distributor && <ErrorInputMsg>{errors.distributor.message}</ErrorInputMsg>}
										</SelectInputDetailHandler>
									</div>
									{!stockRequestCheck && (
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_reseller']}* :</LabelText>
											<SelectInputDetailHandler>
												<SelectInputWrapper>
													<SelectInputCustom
														width="208"
														name="reseller"
														disabled={
															(!isEditable && !isEditableSecondCycle) ||
															(kioskCreation.forceReadOnly && isEditableSecondCycle)
														}
														ref={register({
															required: {
																value: true,
																message: translations['common__text__requiredField'],
															},
															validate: (value) => value > 0 || translations['common__text__requiredField'],
														})}
														className={watch('reseller') > 0 ? 'active' : ''}
														onChange={(e) => handleResellerChange(e.target.value)}
													>
														<OptionCustom value="0" hidden>
															{translations['page_admin_initKiosk_stepOne_sheet_reseller_placeholder']}
														</OptionCustom>
														{map(kioskCreationDefinitionOptions.reseller, (elem, id) => {
															return (
																<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																	{elem.details.companyName}
																</OptionCustom>
															)
														})}
													</SelectInputCustom>
													{!isUndefined(currentReseller) && (
														<a onClick={() => handleOpenModals({}, 'handleModalReseller')}>
															{translations['page_admin_initKiosk_stepOne_sheet_linkTo_viewDetails']}
														</a>
													)}
												</SelectInputWrapper>
												{errors.reseller && <ErrorInputMsg>{errors.reseller.message}</ErrorInputMsg>}
											</SelectInputDetailHandler>
										</div>
									)}
									{/*DEBUT AJOUT*/}

									{customerValidated && !stockRequestCheck && (
										<KioskCreationDefinitionBusinessInfo>
											<div>
												<span>{translations['page_admin_initKiosk_stepOne_sheet_maintainer_title']}</span>
												<Tooltip
													tooltipId={'kioskCreationDefinitionCustomerDisplayStoreInfo'}
													translationsKey={
														showTechSupportInfo
															? 'tooltip_admin_initKiosk_stepOne_hide'
															: 'tooltip_admin_initKiosk_stepOne_display'
													}
												>
													<img
														src={showTechSupportInfo ? CloseEyeIcon : OpenEyeIcon}
														onClick={() => setShowTechSupportInfo(!showTechSupportInfo)}
													/>
												</Tooltip>
											</div>
											{showTechSupportInfo && (
												<KioskCreationDefinitionBusinessInfoPart>
													<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_maintainer_input']} :</LabelText>
													<span>{kioskCreationDefinition.data.userCreatedStoreInfo.maintainer}</span>
												</KioskCreationDefinitionBusinessInfoPart>
											)}
										</KioskCreationDefinitionBusinessInfo>
									)}

									{!stockRequestCheck && (
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_maintainer_placeholder']}* :</LabelText>
											<SelectInputDetailHandler>
												<SelectInputWrapper>
													<SelectInputCustom
														width="208"
														//name="reseller"
														name="maintainer"
														disabled={
															(!isEditable && !isEditableSecondCycle) ||
															(kioskCreation.forceReadOnly && isEditableSecondCycle)
														}
														ref={register({
															required: {
																value: true,
																message: translations['common__text__requiredField'],
															},
															validate: (value) => value > 0 || translations['common__text__requiredField'],
														})}
														className={watch('maintainer') > 0 ? 'active' : ''}
														onChange={(e) => handleMaintainerChange(e.target.value)}
													>
														<OptionCustom value="0" hidden>
															{translations['page_admin_initKiosk_stepOne_sheet_maintainer_placeholder']}
														</OptionCustom>
														{!isUndefined(currentOwner) &&
															map(currentOwner?.maintainers, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																		{elem.details.companyName}
																	</OptionCustom>
																)
															})}
													</SelectInputCustom>
													{!isUndefined(currentMaintainer) && (
														<a onClick={() => handleOpenModals({}, 'handleModalMaintainer')}>
															{translations['page_admin_initKiosk_stepOne_sheet_linkTo_viewDetails']}
														</a>
													)}
												</SelectInputWrapper>
												{errors.maintainer && <ErrorInputMsg>{errors.maintainer.message}</ErrorInputMsg>}
											</SelectInputDetailHandler>
										</div>
									)}

									{/*FIN AJOUT*/}

									{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.view[20])) &&
										!stockRequestCheck && (
											<div style={{ width: '208px' }}>
												<TooltipHelp childrenPos={1} content={'tooltip_admin_initKiosk_stepOne_companyManagement'}>
													<Link
														onClick={() => (isEditable || isEditableSecondCycle) && setShowModalCompaniesManager(true)}
														style={{ textDecoration: 'none' }}
													>
														<Button
															weight="bold"
															text={translations['page_admin_initKiosk_stepOne_button_companyManage']}
															height={32}
															disabled={
																(!isEditable && !isEditableSecondCycle) ||
																(kioskCreation.forceReadOnly && isEditableSecondCycle)
															}
														/>
													</Link>
												</TooltipHelp>
											</div>
										)}
									{!stockRequestCheck && (
										<Fragment>
											<div>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_photo']} :</LabelText>
											</div>
											<UploadFileList>
												{!isEmpty(kioskCreationDefinition.data?.pictures) &&
													map(kioskCreationDefinition.data?.pictures, (pict, key) => {
														const imgname = _.last(pict.split('/'))
														return (
															<div>
																<span>{imgname}</span>
																<Tooltip
																	tooltipId={`pictureLink_${key}`}
																	translationsKey={'tooltip_admin_initKiosk_stepOne_download'}
																>
																	<a href={`/${pict}`} target="_blank">
																		<PictureLink src={OpenEyeIcon} />
																	</a>
																</Tooltip>
															</div>
														)
													})}
											</UploadFileList>
										</Fragment>
									)}
								</KioskCreationDefinitionBusinessContentPart>
							</KioskCreationDefinitionBusinessPart>
						</KioskCreationDefinitionBusinessColumn>
						<KioskCreationDefinitionBusinessColumn>
							<KioskCreationDefinitionBusinessTitlePart>
								{translations['page_admin_initKiosk_stepOne_sheet_contactInformation']}
							</KioskCreationDefinitionBusinessTitlePart>
							{customerValidated && (
								<KioskCreationDefinitionBusinessInfo>
									<div>
										<span>{translations['page_admin_initKiosk_stepOne_sheet_userRequestInformation']}</span>
										<Tooltip
											tooltipId={'kioskCreationDefinitionCustomerDisplayAccountInfo'}
											translationsKey={
												showAccountInfo ? 'tooltip_admin_initKiosk_stepOne_hide' : 'tooltip_admin_initKiosk_stepOne_display'
											}
										>
											<img
												src={showAccountInfo ? CloseEyeIcon : OpenEyeIcon}
												onClick={() => setShowAccountInfo(!showAccountInfo)}
											/>
										</Tooltip>
									</div>
									{showAccountInfo && (
										<KioskCreationDefinitionBusinessInfoPart>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_lastname']} :</LabelText>
											<span>
												{isUpdate
													? kioskCreationDefinition.data?.userCreated?.lastName
													: kioskCreationDefinitionOptions.userCreated.lastName}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_firstname']} :</LabelText>
											<span>
												{isUpdate
													? kioskCreationDefinition.data?.userCreated?.firstName
													: kioskCreationDefinitionOptions.userCreated.firstName}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_email']} :</LabelText>
											<span>
												{isUpdate
													? kioskCreationDefinition.data?.userCreated?.email
													: kioskCreationDefinitionOptions.userCreated.email}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_phone']} :</LabelText>
											<span>
												{isUpdate
													? kioskCreationDefinition.data?.userCreated?.phoneNumber
													: kioskCreationDefinitionOptions.userCreated.phoneNumber}
											</span>
										</KioskCreationDefinitionBusinessInfoPart>
									)}
								</KioskCreationDefinitionBusinessInfo>
							)}
							{!stockRequestCheck && (
								<KioskCreationDefinitionBusinessContentPart>
									<SpanTitle>{translations['page_admin_initKiosk_stepOne_sheet_storeContactInformation']}</SpanTitle>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_lastname']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactLastName"
												disabled={!isEditable}
												type="text"
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_lastname_placeholder']}
												ref={register({
													maxLength: {
														value: 250,
														message: `250 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
												})}
											/>
											{errors.contactLastName && <ErrorInputMsg>{errors.contactLastName.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_firstname']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactFirstName"
												disabled={!isEditable}
												type="text"
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_firstname_placeholder']}
												ref={register({
													maxLength: {
														value: 250,
														message: `250 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
												})}
											/>
											{errors.contactFirstName && <ErrorInputMsg>{errors.contactFirstName.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_email']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactEmail"
												disabled={!isEditable}
												type="text"
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_email_placeholder']}
												ref={register({
													maxLength: {
														value: 150,
														message: `150 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
													pattern: {
														value: RegExp(
															/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
														),
														message: translations['common__text__invalidEmail'],
													},
												})}
											/>
											{errors.contactEmail && <ErrorInputMsg>{errors.contactEmail.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_phone']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactPhoneNumber"
												disabled={!isEditable}
												type="text"
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_phone_placeholder']}
												ref={register({
													maxLength: {
														value: 250,
														message: `250 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
												})}
											/>
											{errors.contactPhoneNumber && <ErrorInputMsg>{errors.contactPhoneNumber.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
								</KioskCreationDefinitionBusinessContentPart>
							)}
						</KioskCreationDefinitionBusinessColumn>
						<KioskCreationDefinitionBusinessColumn>
							<KioskCreationDefinitionBusinessTitlePart>
								{translations['page_admin_initKiosk_stepOne_sheet_kioskInformation']}
							</KioskCreationDefinitionBusinessTitlePart>
							<KioskCreationDefinitionBusinessContentPart>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_model']}* :</LabelText>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="kioskModel"
												disabled={!isEditable}
												ref={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) =>
														(value > 0 && !stockRequestCheck) ||
														stockRequestCheck ||
														translations['common__text__requiredField'],
												})}
												className={watch('kioskModel') > 0 ? 'active' : ''}
												onChange={(e) => handleChangeKioskModel(e.target.value)}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_kiosk_model_placeholder']}
												</OptionCustom>
												{map(kioskCreationDefinitionOptions.kioskModels, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
															{elem.label}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.kioskModel && <ErrorInputMsg>{errors.kioskModel.message}</ErrorInputMsg>}
									</div>
								</div>
							</KioskCreationDefinitionBusinessContentPart>
							{!stockRequestCheck && (
								<Fragment>
									<KioskCreationDefinitionBusinessContentPart>
										<div>
											<LabelText>
												{translations['page_admin_initKiosk_stepOne_sheet_kiosk_kioskCodeWD']} :{' '}
												<KioskCodeWDLabel>{kioskCreationDefinition.data.kioskInformation?.kioskCode}</KioskCodeWDLabel>
											</LabelText>
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_name']} :</LabelText>
											<InputWrapper>
												<InputLogin
													name="kioskLabelToOwner"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_kiosk_name_placeholder']}
													ref={register({
														maxLength: {
															value: 250,
															message: `250 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
														validate: (value) =>
															KioskPdvHelper.isPdvValid(value, getValues('kioskDescription')) ||
															translations['common__message__kiosk_pdv_wrongFormat'],
													})}
												/>
												{errors.kioskLabelToOwner && <ErrorInputMsg>{errors.kioskLabelToOwner.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_label']}* :</LabelText>
											<InputWrapper>
												<InputLogin
													name="kioskDescription"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_kiosk_label_placeholder']}
													ref={register({
														required: {
															value: true,
															message: translations['common__text__requiredField'],
														},
													})}
												/>
												{errors.kioskDescription && <ErrorInputMsg>{errors.kioskDescription.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_installationDate']}* :</LabelText>
											<CalendarInputInline
												name="kioskDateInstallation"
												disabled={
													(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)
												}
												onClickHandler={dateInstallOpenDateModalHandler}
												valueInput={
													!isUndefined(currentDateInstall.date.startDate)
														? `${moment(currentDateInstall.date.startDate).format('DD/MM/YYYY')}`
														: ''
												}
											/>
											{errors.kioskDateInstallation && <ErrorInputMsg>{errors.kioskDateInstallation.message}</ErrorInputMsg>}
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_deliveryDate']} :</LabelText>
											<CalendarInputInline
												name="kioskDateDelivery"
												disabled={
													(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)
												}
												onClickHandler={dateDeliveryOpenDateModalHandler}
												valueInput={
													!isUndefined(currentDateDelivery.date.startDate)
														? `${moment(currentDateDelivery.date.startDate).format('DD/MM/YYYY')}`
														: ''
												}
											/>
											{errors.kioskDateDelivery && <ErrorInputMsg>{errors.kioskDateDelivery.message}</ErrorInputMsg>}
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_warranty']} :</LabelText>
											<div>
												<SelectInputWrapper>
													<SelectInputCustom
														width="208"
														name="kioskWarranty"
														disabled={
															(!isEditable && !isEditableSecondCycle) ||
															(kioskCreation.forceReadOnly && isEditableSecondCycle)
														}
														ref={register({
															required: {
																value: false,
																message: translations['common__text__requiredField'],
															},
															//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
														})}
														className={watch('kioskWarranty') > 0 ? 'active' : ''}
													>
														<OptionCustom value="0" hidden>
															{translations['page_admin_initKiosk_stepOne_sheet_kiosk_warranty_placeholder']}
														</OptionCustom>
														{map(kioskCreationDefinitionOptions.warranty, (elem, id) => {
															return (
																<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																	{elem.label}
																</OptionCustom>
															)
														})}
													</SelectInputCustom>
												</SelectInputWrapper>
												{errors.kioskWarranty && <ErrorInputMsg>{errors.kioskWarranty.message}</ErrorInputMsg>}
											</div>
										</div>
									</KioskCreationDefinitionBusinessContentPart>
								</Fragment>
							)}
							{!stockRequestCheck && (
								<Fragment>
									<KioskCreationDefinitionBusinessContentPart>
										<div style={{ marginTop: !stockRequestCheck ? '10px' : '0px' }}>
											<LabelText>
												{translations['page_admin_initKiosk_stepOne_sheet_kiosk_language']}
												{!stockRequestCheck ? '*' : ''} :
											</LabelText>

											{translations && kioskCreationDefinitionOptions.availableLanguages && (
												<div>
													<SelectInputWrapper>
														<SelectInputCustom
															width="208"
															name="kioskLanguage"
															disabled={
																(!isEditable && !isEditableSecondCycle) ||
																(kioskCreation.forceReadOnly && isEditableSecondCycle)
															}
															readOnly={customerValidated}
															ref={register({
																required: {
																	value: !stockRequestCheck,
																	message: translations['common__text__requiredField'],
																},
																validate: (value) =>
																	(value > 0 && !stockRequestCheck) ||
																	stockRequestCheck ||
																	translations['common__text__requiredField'],
															})}
															className={watch('kioskLanguage') > 0 ? 'active' : ''}
														>
															{customerValidated && kioskCreationDefinition ? (
																<OptionCustom
																	value={
																		find(kioskCreationDefinition.data.availableLanguages, { selected: true })?.id
																	}
																	hidden
																>
																	{
																		find(kioskCreationDefinition.data.availableLanguages, { selected: true })
																			?.labelEnglish
																	}
																</OptionCustom>
															) : (
																<OptionCustom value="0" hidden>
																	{translations['page_admin_initKiosk_stepOne_sheet_kiosk_language_model']}
																</OptionCustom>
															)}
															<Fragment>
																{map(kioskCreationDefinitionOptions.availableLanguages, (elem, id) => {
																	return (
																		<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																			{elem.labelEnglish}
																		</OptionCustom>
																	)
																})}
															</Fragment>
														</SelectInputCustom>
													</SelectInputWrapper>
													{errors.kioskLanguage && <ErrorInputMsg>{errors.kioskLanguage.message}</ErrorInputMsg>}
												</div>
											)}
										</div>
									</KioskCreationDefinitionBusinessContentPart>
									<KioskCreationDefinitionBusinessTogglePart visible={true}>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_pda']} :</LabelText>
											<Controller
												control={control}
												name="pda"
												as={ToggleFilters}
												checked={currentPageSwitches?.pda}
												onChangeHandler={() => handleSwitchChange('pda')}
												disabled={
													(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)
												}
												reverseCheck
												size="large"
												rules={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
												})}
												labelPrev={translations['common__text__yes']}
												labelNext={translations['common__text__no']}
											/>
										</div>
									</KioskCreationDefinitionBusinessTogglePart>
									<KioskCreationDefinitionBusinessContentPart>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_message']} :</LabelText>
											<InputWrapper>
												<InputLogin
													name="welcomeMessage"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													readOnly={customerValidated && !isEditableSecondCycle}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_kiosk_message_placeholder']}
													ref={register({
														maxLength: {
															value: 200,
															message: `200 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
													})}
													width={'100%'}
												/>
												{errors.welcomeMessage && <ErrorInputMsg>{errors.welcomeMessage.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
									</KioskCreationDefinitionBusinessContentPart>
								</Fragment>
							)}
							{!stockRequestCheck && (
								<KioskCreationDefinitionBusinessContentPart>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_installationType']} :</LabelText>
										<div>
											<SelectInputWrapper>
												<SelectInputCustom
													width="208"
													name="installationType"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													ref={register({
														required: {
															value: false, //!stockRequestCheck,
															message: translations['common__text__requiredField'],
														},
														//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
													})}
													className={watch('installationType') > 0 ? 'active' : ''}
												>
													<OptionCustom value="0" hidden>
														{translations['page_admin_initKiosk_stepOne_sheet_kiosk_installationType_placeholder']}
													</OptionCustom>
													{map(kioskCreationDefinitionOptions.installationTypes, (elem, id) => {
														return (
															<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																{translations[elem.translationKey]}
															</OptionCustom>
														)
													})}
												</SelectInputCustom>
											</SelectInputWrapper>
											{errors.installationType && <ErrorInputMsg>{errors.installationType.message}</ErrorInputMsg>}
										</div>
									</div>
								</KioskCreationDefinitionBusinessContentPart>
							)}
							<KioskCreationDefinitionBusinessTogglePart visible={true}>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_solidDoor']} :</LabelText>
									<Controller
										control={control}
										name="solidDoor"
										as={ToggleFilters}
										checked={currentPageSwitches.solidDoor}
										onChangeHandler={() => handleSwitchChange('solidDoor')}
										disabled={!isEditable}
										size="large"
										reverseCheck
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_lateralPanel']} :</LabelText>
									<Controller
										control={control}
										name="lateralPanel"
										as={ToggleFilters}
										checked={currentPageSwitches?.lateralPanel}
										onChangeHandler={() => handleSwitchChange('lateralPanel')}
										disabled={!isEditable}
										size="large"
										reverseCheck
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_interiorCover']} :</LabelText>
									<Controller
										control={control}
										name="interiorCover"
										as={ToggleFilters}
										checked={currentPageSwitches?.interiorCover}
										onChangeHandler={() => handleSwitchChange('interiorCover')}
										disabled={!isEditable}
										size="large"
										reverseCheck
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div style={{ display: `${!stockRequestCheck ? 'flex' : 'none'}` }}>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_restrictedLocation']} :</LabelText>
									<Controller
										control={control}
										name="restrictedLocation"
										as={ToggleFilters}
										checked={currentPageSwitches?.restrictedLocation}
										onChangeHandler={() => handleSwitchChange('restrictedLocation')}
										disabled={(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)}
										size="large"
										reverseCheck
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
							</KioskCreationDefinitionBusinessTogglePart>
							{customerValidated && (
								<KioskCreationDefinitionBusinessInfo>
									<div>
										<span>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_fieldsFilled']}</span>
										<Tooltip
											tooltipId={'kioskCreationDefinitionCustomerDisplayKioskInfo'}
											translationsKey={
												showKioskInfo ? 'tooltip_admin_initKiosk_stepOne_hide' : 'tooltip_admin_initKiosk_stepOne_display'
											}
										>
											<img src={showKioskInfo ? CloseEyeIcon : OpenEyeIcon} onClick={() => setShowKioskInfo(!showKioskInfo)} />
										</Tooltip>
									</div>
									{showKioskInfo && (
										<KioskCreationDefinitionBusinessInfoPart>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_model']} :</LabelText>
											<span>{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.kioskModel]}</span>
											{!stockRequestCheck && (
												<Fragment>
													<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_name']} :</LabelText>
													<span>
														{kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.kioskLabelToOwner}
													</span>
													<LabelText>
														{translations['page_admin_initKiosk_stepOne_sheet_kiosk_installationDate']} :
													</LabelText>
													<span>
														{kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.kioskDateInstallation}
													</span>
													<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_language']} :</LabelText>
													<span>
														{stockRequestCheck
															? translations['common__text__no']
															: kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.kioskLanguage}
													</span>
													<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_pda']} :</LabelText>
													<span>
														{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.pda]}
													</span>
													<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_message']} :</LabelText>
													<span>{kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.welcomeMessage}</span>
													<LabelText>
														{translations['page_admin_initKiosk_stepOne_sheet_kiosk_installationType']} :
													</LabelText>
													<span>
														{
															translations[
																kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.installationType
															]
														}
													</span>
												</Fragment>
											)}
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_solidDoor']} :</LabelText>
											<span>
												{translations[kioskCreationDefinition.data?.kioskInformation?.userCreatedKioskInfo?.solidDoor]}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_lateralPanel']} :</LabelText>
											<span>
												{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.lateralPanel]}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_interiorCover']} :</LabelText>
											<span>
												{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.interiorCover]}
											</span>
											{!stockRequestCheck && (
												<Fragment>
													<LabelText>
														{translations['page_admin_initKiosk_stepOne_sheet_kiosk_restrictedLocation']} :
													</LabelText>
													<span>
														{
															translations[
																kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.restrictedLocation
															]
														}
													</span>
												</Fragment>
											)}
										</KioskCreationDefinitionBusinessInfoPart>
									)}
								</KioskCreationDefinitionBusinessInfo>
							)}
							<KioskCreationDefinitionBusinessTitlePart>
								{translations['page_admin_initKiosk_stepOne_sheet_kioskOption_configuration']}
							</KioskCreationDefinitionBusinessTitlePart>
							{customerValidated && (
								<KioskCreationDefinitionBusinessInfo>
									<div>
										<span>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_fieldsFilled']}</span>
										<Tooltip
											tooltipId={'kioskCreationDefinitionCustomerDisplayKioskConfigInfo'}
											translationsKey={
												showKioskConfigInfo
													? 'tooltip_admin_initKiosk_stepOne_hide'
													: 'tooltip_admin_initKiosk_stepOne_display'
											}
										>
											<img
												src={showKioskConfigInfo ? CloseEyeIcon : OpenEyeIcon}
												onClick={() => setShowKioskConfigInfo(!showKioskConfigInfo)}
											/>
										</Tooltip>
									</div>
									{showKioskConfigInfo && (
										<KioskCreationDefinitionBusinessInfoPart>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_platineSet']} :</LabelText>
											<span>{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.platineSet]}</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_marker']} :</LabelText>
											<span>{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.marker]}</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleDetaction']} :</LabelText>
											<span>
												{
													translations[
														kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.bottleDetectionAvailable
													]
												}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleMatterSensor']} :</LabelText>
											<span>
												{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.bottleMatterSensor]}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_codePayment']} :</LabelText>
											<span>
												{
													translations[
														kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.codePaymentAvailable
													]
												}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_tpa']} :</LabelText>
											<span>
												{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.tpaAvailable]}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_scale']} :</LabelText>
											<span>
												{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.scaleAvailable]}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_printer']} :</LabelText>
											<span>
												{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.printerAvailable]}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_ticket']} :</LabelText>
											<span>
												{
													translations[
														kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.ticketByMailAvailable
													]
												}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_solar']} :</LabelText>
											<span>
												{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.solarPanelAvailable]}
											</span>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_barCodeReader']} :</LabelText>
											<span>
												{translations[kioskCreationDefinition.data.kioskInformation.userCreatedKioskInfo.barCodeReader]}
											</span>
										</KioskCreationDefinitionBusinessInfoPart>
									)}
								</KioskCreationDefinitionBusinessInfo>
							)}
							<KioskCreationDefinitionBusinessContentPart>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kioskConfigInformation']}* :</LabelText>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="kioskOwnerConfig"
												disabled={!isEditable || kioskCreation.statusId >= 3}
												ref={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) => value > 0 || translations['common__text__requiredField'],
												})}
												className={watch('kioskOwnerConfig') > 0 ? 'active' : ''}
												onChange={(e) => handleChangeProfile(e.target.value)}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_kioskPrfile_placeholder']}
												</OptionCustom>
												{map(kioskCreationDefinitionOptions.kioskOwnerConfigs, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
															{elem.label}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.kioskOwnerConfig && <ErrorInputMsg>{errors.kioskOwnerConfig.message}</ErrorInputMsg>}
									</div>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_implatationConfig']}* :</LabelText>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="idDisplayStandImplantation"
												disabled={!isEditable}
												ref={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) => value > 0 || translations['common__text__requiredField'],
												})}
												className={watch('idDisplayStandImplantation') > 0 ? 'active' : ''}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_selectConfig_placeholder']}
												</OptionCustom>
												{map(kioskCreationDefinitionOptions.displayStandsImplantation, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
															{translations[elem.translationKey]}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.idDisplayStandImplantation && (
											<ErrorInputMsg>{errors.idDisplayStandImplantation.message}</ErrorInputMsg>
										)}
									</div>
								</div>
							</KioskCreationDefinitionBusinessContentPart>
							<KioskCreationDefinitionBusinessTogglePart visible={!isEqual(selectedProfile, {})}>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_platineSet']} :</LabelText>
									<Controller
										control={control}
										name="platineSet"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().platineSet}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('platineSet')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_marker']} :</LabelText>
									<Controller
										control={control}
										name="marker"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().marker}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('marker')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleDetaction']} :</LabelText>
									<Controller
										control={control}
										name="bottleDetectionAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().bottleDetectionAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('bottleDetectionAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								{/*<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleColorSensor']}* :</LabelText>
									<Controller
										control={control}
										name="bottleColorSensor"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={selectedProfile.bottleColorSensor}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange("bottleColorSensor")
										}}
										rules={ register( {
													required: {
														value: true,
														message: translations['common__text__requiredField']
													},
											} ) }
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleTopSensor']}* :</LabelText>
									<Controller
										control={control}
										name="bottleTopSensor"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={selectedProfile.bottleTopSensor}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange("bottleTopSensor")
										}}
										rules={ register( {
													required: {
														value: true,
														message: translations['common__text__requiredField']
													},
											} ) }
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleBottomSensor']}* :</LabelText>
									<Controller
										control={control}
										name="bottleBottomSensor"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={selectedProfile.bottleBottomSensor}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange("bottleBottomSensor")
										}}
										rules={ register( {
													required: {
														value: true,
														message: translations['common__text__requiredField']
													},
											} ) }
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>*/}
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleMatterSensor']} :</LabelText>
									<Controller
										control={control}
										name="bottleMatterSensor"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().bottleMatterSensor}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('bottleMatterSensor')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_codePayment']} :</LabelText>
									<Controller
										control={control}
										name="codePaymentAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().codePaymentAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('codePaymentAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_tpa']} :</LabelText>
									<Controller
										control={control}
										name="tpaAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().tpaAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('tpaAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div style={{ display: `${selectedProfile.tpaAvailable ? 'inherit' : 'none'}` }}>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_tpaMOdel']} :</LabelText>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="kioskTpaModel"
												disabled={!isEditable}
												ref={register({
													required: {
														value: false, //!stockRequestCheck,
														message: translations['common__text__requiredField'],
													},
													//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
												})}
												className={watch('kioskTpaModel') > 0 || selectedProfile.tpaModel > 0 ? 'active' : ''}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_kiosk_tpaMOdel_placeholder']}
												</OptionCustom>
												{map(kioskCreationDefinitionOptions.tpaModel, (elem, id) => {
													return (
														<OptionCustom
															key={id}
															value={elem.id}
															selected={elem.selected || selectedProfile.tpaModel === elem.id}
															target={true}
														>
															{elem.label}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.kioskTpaModel && <ErrorInputMsg>{errors.kioskTpaModel.message}</ErrorInputMsg>}
									</div>
								</div>
								<div style={{ display: `${selectedProfile.tpaAvailable ? 'inherit' : 'none'}` }}>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_integrator']} :</LabelText>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="kioskTpaIntegrator"
												disabled={!isEditable}
												ref={register({
													required: {
														value: false, //!stockRequestCheck,
														message: translations['common__text__requiredField'],
													},
													//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
												})}
												className={watch('kioskTpaIntegrator') > 0 || selectedProfile.integrator > 0 ? 'active' : ''}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_kiosk_integrator_placeholder']}
												</OptionCustom>
												{map(kioskCreationDefinitionOptions.integrator, (elem, id) => {
													return (
														<OptionCustom
															key={id}
															value={elem.id}
															selected={elem.selected || selectedProfile.integrator === elem.id}
															target={true}
														>
															{elem.label}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.kioskTpaIntegrator && <ErrorInputMsg>{errors.kioskTpaIntegrator.message}</ErrorInputMsg>}
									</div>
								</div>
								{/*<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_energyCard']}* :</LabelText>
									<Controller
										control={control}
										name="energyCard"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={selectedProfile.energyCard}		
										reverseCheck							
										onChangeHandler={() => {
											handleProfileSelectedChange("energyCard")
										}}
										rules={ register( {
													required: {
														value: true,
														message: translations['common__text__requiredField']
													},
											} ) }
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>*/}
								<div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_conectivity']} :</LabelText>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="kioskConnectivity"
												disabled={!isEditable}
												ref={register({
													required: {
														value: false, //!stockRequestCheck,
														message: translations['common__text__requiredField'],
													},
													//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
												})}
												className={watch('kioskConnectivity') > 0 || selectedProfile.connectivity > 0 ? 'active' : ''}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_kiosk_conectivity_placeholder']}
												</OptionCustom>
												{map(kioskCreationDefinitionOptions.connectivity, (elem, id) => {
													return (
														<OptionCustom
															key={id}
															value={elem.id}
															selected={elem.selected || selectedProfile.connectivity === elem.id}
															target={true}
														>
															{elem.label}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.kioskConnectivity && <ErrorInputMsg>{errors.kioskConnectivity.message}</ErrorInputMsg>}
									</div>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_scale']} :</LabelText>
									<Controller
										control={control}
										name="scaleAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().scaleAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('scaleAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_printer']} :</LabelText>
									<Controller
										control={control}
										name="printerAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().printerAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('printerAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_ticket']} :</LabelText>
									<Controller
										control={control}
										name="ticketByMailAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().ticketByMailAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('ticketByMailAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_solar']} :</LabelText>
									<Controller
										control={control}
										name="solarPanelAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().solarPanelAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('solarPanelAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_barCodeReader']} :</LabelText>
									<Controller
										control={control}
										name="barCodeReader"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().barCodeReader}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('barCodeReader')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
							</KioskCreationDefinitionBusinessTogglePart>
						</KioskCreationDefinitionBusinessColumn>
						<KioskCreationDefinitionBusinessColumn>
							<KioskCreationDefinitionBusinessTitlePart>
								{translations['page_admin_initKiosk_stepOne_sheet_rackInformation']}
							</KioskCreationDefinitionBusinessTitlePart>
							<KioskCreationDefinitionBusinessContentPart>
								{!isEqual(kioskCreationDefinition.data, {}) && (
									<KioskCreationDefinitionBusinessInfo>
										<div>
											<span>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_fieldsFilled']}</span>
											<Tooltip
												tooltipId={'kioskCreationDefinitionCustomerDisplayKioskInfo'}
												translationsKey={
													showCustomerRacksInfo
														? 'tooltip_admin_initKiosk_stepOne_hide'
														: 'tooltip_admin_initKiosk_stepOne_display'
												}
											>
												<img
													src={showCustomerRacksInfo ? CloseEyeIcon : OpenEyeIcon}
													onClick={() => setShowCustomerRacksInfo(!showCustomerRacksInfo)}
												/>
											</Tooltip>
										</div>
										{showCustomerRacksInfo &&
											kioskCreationDefinition.data.kioskInformation?.noteCommercial !==
												null /* && selectedProfile.standardProfile*/ && (
												<div>
													<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_salesmenMessage']} :</LabelText>
													<span>{kioskCreationDefinition.data.kioskInformation?.noteCommercial}</span>
												</div>
											)}
										{showCustomerRacksInfo &&
											kioskCreationDefinition.data.kioskInformation?.noteCommercial ===
												null /*&& !selectedProfile.standardProfile*/ &&
											!isEmpty(recapRackCustomer) && (
												<div>
													<KioskCreationDefinitionBusinessRacksInfoPart level={0}>
														<li>
															<div>
																<span>{translations['page_admin_initKiosk_stepOne_sheet_rackNumber']} :</span>
																{(recapRackCustomer?.foldedList.length > 0 ||
																	recapRackCustomer?.notFoldedList.length > 0) && (
																	<span>
																		{recapRackCustomer?.foldedList.length +
																			recapRackCustomer?.notFoldedList.length}
																	</span>
																)}
															</div>
														</li>
														<li>
															<KioskCreationDefinitionBusinessRacksInfoPart level={1}>
																<li>
																	<div>
																		<span>
																			{translations['page_admin_initKiosk_stepOne_sheet_whoseFoldable']} :
																		</span>{' '}
																		<span></span>
																	</div>
																	<KioskCreationDefinitionBusinessRacksInfoPart level={2}>
																		{map(recapRackCustomer?.foldedList, (elem) => (
																			<li>
																				<div>
																					<span>
																						{translations['page_admin_initKiosk_stepOne_sheet_whose']}{' '}
																						{elem.label}
																					</span>{' '}
																					<span>{elem.count}</span>
																				</div>
																			</li>
																		))}
																	</KioskCreationDefinitionBusinessRacksInfoPart>
																</li>
																<li>
																	<div>
																		<span>
																			{translations['page_admin_initKiosk_stepOne_sheet_whoseUnfoldable']} :
																		</span>{' '}
																		<span></span>
																	</div>
																	<KioskCreationDefinitionBusinessRacksInfoPart level={2}>
																		{map(recapRackCustomer?.notFoldedList, (elem) => (
																			<li>
																				<div>
																					<span>
																						{translations['page_admin_initKiosk_stepOne_sheet_whose']}{' '}
																						{elem.label}
																					</span>{' '}
																					<span>{elem.count}</span>
																				</div>
																			</li>
																		))}
																	</KioskCreationDefinitionBusinessRacksInfoPart>
																</li>
															</KioskCreationDefinitionBusinessRacksInfoPart>
														</li>
													</KioskCreationDefinitionBusinessRacksInfoPart>
													<KioskCreationDefinitionBusinessRacksInfoPart level={0}>
														<li>
															<div>
																<span>{translations['page_admin_initKiosk_stepOne_sheet_lockersNumber']} :</span>
																{(recapRackCustomer?.smallLockerNumbers > 0 ||
																	recapRackCustomer?.mediumLockerNumbers > 0 ||
																	recapRackCustomer?.largeLockerNumbers > 0 ||
																	recapRackCustomer?.extraLargeLockerNumbers > 0) && (
																	<span>
																		{recapRackCustomer?.smallLockerNumbers +
																			recapRackCustomer?.mediumLockerNumbers +
																			recapRackCustomer?.largeLockerNumbers +
																			recapRackCustomer?.extraLargeLockerNumbers}
																	</span>
																)}
															</div>
														</li>
														<KioskCreationDefinitionBusinessRacksInfoPart level={1}>
															<li>
																<div>
																	<span>
																		{translations['page_admin_initKiosk_stepOne_sheet_accessory_locker']} :
																	</span>
																	{recapRackCustomer?.smallLockerNumbers > 0 && (
																		<span>{recapRackCustomer?.smallLockerNumbers}</span>
																	)}
																</div>
															</li>
															<li>
																<div>
																	<span>
																		{translations['page_admin_initKiosk_stepOne_sheet_smallBottle_locker']} :
																	</span>
																	{recapRackCustomer?.mediumLockerNumbers > 0 && (
																		<span>{recapRackCustomer?.mediumLockerNumbers}</span>
																	)}
																</div>
															</li>
															<li>
																<div>
																	<span>
																		{translations['page_admin_initKiosk_stepOne_sheet_mediumBottle_locker']} :
																	</span>
																	{recapRackCustomer?.largeLockerNumbers > 0 && (
																		<span>{recapRackCustomer?.largeLockerNumbers}</span>
																	)}
																</div>
															</li>
															<li>
																<div>
																	<span>
																		{translations['page_admin_initKiosk_stepOne_sheet_largeBottle_locker']} :
																	</span>
																	{recapRackCustomer?.extraLargeLockerNumbers > 0 && (
																		<span>{recapRackCustomer?.extraLargeLockerNumbers}</span>
																	)}
																</div>
															</li>
														</KioskCreationDefinitionBusinessRacksInfoPart>
													</KioskCreationDefinitionBusinessRacksInfoPart>
													{/*<KioskCreationDefinitionBusinessRacksInfoPart level={0}>
											<li>
												<div><span>{translations['page_admin_initKiosk_stepOne_sheet_accessory_locker']}</span>
												{recapRackCustomer?.accessoriesList.length > 0 &&
													renderAccessoriesCount()
												}
												</div>
											</li>
											 <KioskCreationDefinitionBusinessRacksInfoPart level={1}>
												{
													map(recapRackCustomer?.accessoriesList, elem => (
														<li>
															<div><span>{translations['page_admin_initKiosk_stepOne_sheet_whose']} {elem.label}</span> <span>{elem.countRacks*elem.count}</span></div>
														</li>
													))
												}
											</KioskCreationDefinitionBusinessRacksInfoPart>
										</KioskCreationDefinitionBusinessRacksInfoPart>*/}
												</div>
											)}
									</KioskCreationDefinitionBusinessInfo>
								)}
								<KioskCreationDefinitionBusinessInfo themed="white">
									<div>
										<span>{translations['page_admin_initKiosk_stepOne_sheet_requestedRacks_resume']}</span>
									</div>
									<div>
										<KioskCreationDefinitionBusinessRacksInfoPart level={0}>
											<li>
												<div>
													<span>{translations['page_admin_initKiosk_stepOne_sheet_rackNumber']} :</span>
													{addedRackList.length > 0 && <span>{addedRackList.length}</span>}
												</div>
											</li>
											<li>
												<KioskCreationDefinitionBusinessRacksInfoPart level={1}>
													<li>
														<div>
															<span>{translations['page_admin_initKiosk_stepOne_sheet_whoseFoldable']} :</span>{' '}
															<span></span>
														</div>
														<KioskCreationDefinitionBusinessRacksInfoPart level={2}>
															{map(recapRack.foldedList, (elem) => (
																<li>
																	<div>
																		<span>
																			{translations['page_admin_initKiosk_stepOne_sheet_whose']} {elem.label}
																		</span>{' '}
																		<span>{elem.count}</span>
																	</div>
																</li>
															))}
														</KioskCreationDefinitionBusinessRacksInfoPart>
													</li>
													<li>
														<div>
															<span>{translations['page_admin_initKiosk_stepOne_sheet_whoseUnfoldable']} :</span>{' '}
															<span></span>
														</div>
														<KioskCreationDefinitionBusinessRacksInfoPart level={2}>
															{map(recapRack.notFoldedList, (elem) => (
																<li>
																	<div>
																		<span>
																			{translations['page_admin_initKiosk_stepOne_sheet_whose']} {elem.label}
																		</span>{' '}
																		<span>{elem.count}</span>
																	</div>
																</li>
															))}
														</KioskCreationDefinitionBusinessRacksInfoPart>
													</li>
												</KioskCreationDefinitionBusinessRacksInfoPart>
											</li>
										</KioskCreationDefinitionBusinessRacksInfoPart>
										<KioskCreationDefinitionBusinessRacksInfoPart level={0}>
											<li>
												<div>
													<span>{translations['page_admin_initKiosk_stepOne_sheet_lockersNumber']} :</span>
													{(recapRack.smallLockerNumbers > 0 ||
														recapRack.mediumLockerNumbers > 0 ||
														recapRack.largeLockerNumbers > 0 ||
														recapRack.extraLargeLockerNumbers > 0) && (
														<span>
															{recapRack.smallLockerNumbers +
																recapRack.mediumLockerNumbers +
																recapRack.largeLockerNumbers +
																recapRack.extraLargeLockerNumbers}
														</span>
													)}
												</div>
											</li>
											<KioskCreationDefinitionBusinessRacksInfoPart level={1}>
												<li>
													<div>
														<span>{translations['page_admin_initKiosk_stepOne_sheet_accessory_locker']} :</span>
														{recapRack.smallLockerNumbers > 0 && <span>{recapRack.smallLockerNumbers}</span>}
													</div>
												</li>
												<li>
													<div>
														<span>{translations['page_admin_initKiosk_stepOne_sheet_smallBottle_locker']} :</span>
														{recapRack.mediumLockerNumbers > 0 && <span>{recapRack.mediumLockerNumbers}</span>}
													</div>
												</li>
												<li>
													<div>
														<span>{translations['page_admin_initKiosk_stepOne_sheet_mediumBottle_locker']} :</span>
														{recapRack.largeLockerNumbers > 0 && <span>{recapRack.largeLockerNumbers}</span>}
													</div>
												</li>
												<li>
													<div>
														<span>{translations['page_admin_initKiosk_stepOne_sheet_largeBottle_locker']} :</span>
														{recapRack.extraLargeLockerNumbers > 0 && <span>{recapRack.extraLargeLockerNumbers}</span>}
													</div>
												</li>
											</KioskCreationDefinitionBusinessRacksInfoPart>
										</KioskCreationDefinitionBusinessRacksInfoPart>
										{/*<KioskCreationDefinitionBusinessRacksInfoPart level={0}>
											<li>
												<div><span>{translations['page_admin_initKiosk_stepOne_sheet_accessory_locker']}</span>
												{recapRack.accessoriesList.length > 0 &&
													renderAccessoriesCount()
												}
												</div>
											</li>
											<KioskCreationDefinitionBusinessRacksInfoPart level={1}>
												{
													map(recapRack.accessoriesList, elem => (
														<li>
															<div><span>{translations['page_admin_initKiosk_stepOne_sheet_whose']} {elem.label}</span> <span>{elem.countRacks*elem.count}</span></div>
														</li>
													))
												}
											</KioskCreationDefinitionBusinessRacksInfoPart>
										</KioskCreationDefinitionBusinessRacksInfoPart>*/}
									</div>
								</KioskCreationDefinitionBusinessInfo>
								{!isEmpty(addedRackList) && (
									<KioskCreationDefinitionBusinessRacksList>
										{map(addedRackList, (elem, key) => {
											const labelRack =
												elem?.labelRack?.length > 0 ? elem.labelRack : translations[elem.idDisplayStandModelName]
											const labelAccessory = !isUndefined(elem?.idAccessoryDisplayStandModel)
												? elem?.labelAccessory?.length > 0
													? elem.labelAccessory
													: translations[elem.accessoryDisplayStand[0].accessoryDisplayStandModelName]
												: !isEmpty(elem.accessoryDisplayStand) &&
												  translations[elem.accessoryDisplayStand[0].accessoryDisplayStandModelName].length > 0
												? translations[elem.accessoryDisplayStand[0].accessoryDisplayStandModelName]
												: ''
											return (
												<KioskCreationDefinitionBusinessRackItem disabled={!isEditable}>
													<span>{elem?.displayStandName}</span>
													<span>{`${labelRack}${labelAccessory.length > 0 ? '/' : ''}${labelAccessory}`}</span>
													{isEditable && (
														<Tooltip
															tooltipId={'kioskCreationDefinitionBusinessDeleteRack'}
															translationsKey={'tooltip_admin_initKiosk_stepOne_sheet_deleteRack'}
														>
															<img
																src={DeleteRackIcon}
																onClick={() => handleRackList('delete', key, labelRack, labelAccessory)}
															/>
														</Tooltip>
													)}
												</KioskCreationDefinitionBusinessRackItem>
											)
										})}
									</KioskCreationDefinitionBusinessRacksList>
								)}
								{!isEqual(selectedProfile, {}) && (
									<Fragment>
										<div>
											<div>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_productionMessage']} :</LabelText>
											</div>
											<InputWrapper>
												<TextareaStyled
													name="noteProduction"
													disabled={!isEditable}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_kioskDetailsMessage_placeholder']}
													ref={register({
														maxLength: {
															value: 300,
															message: `300 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
													})}
												/>
												{errors.noteProduction && <ErrorInputMsg>{errors.noteProduction.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>

										<KioskCreationDefinitionBusinessRacksPart>
											<Fragment>
												<div>
													<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_rackModel']} :</LabelText>
												</div>
												<div>
													<SelectInputWrapper>
														<SelectInputCustom
															width="208"
															name="idDisplayStandModel"
															disabled={!isEditable}
															ref={register({
																required: {
																	value: false,
																	message: translations['common__text__requiredField'],
																},
																//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
															})}
															className={watch('idDisplayStandModel') > 0 ? 'active' : ''}
															onChange={(e) => handleChangeRack(e.target.value)}
														>
															<OptionCustom value="0" hidden>
																{translations['page_admin_initKiosk_stepOne_sheet_rackModel_placeholder']}
															</OptionCustom>
															{map(availableRackList, (elem, id) => {
																const mainRackCount = _.countBy(addedRackList, (o) => o.isMain)
																const multiMainRackCount = _.countBy(addedRackList, (o) => o.allowMultiMain)
																return (
																	<OptionCustom
																		key={id}
																		value={elem.id}
																		target={true}
																		//hidden={((isEmpty(addedRackList) && !elem.isMain)) || (!secondaryAvailable && !elem.isMain)}
																		hidden={
																			(!isUndefined(mainRackCount.true) &&
																				isUndefined(multiMainRackCount.true) &&
																				elem.isMain) ||
																			(!isUndefined(multiMainRackCount.true) &&
																				elem.isMain &&
																				!elem.allowMultiMain) ||
																			(!elem.isMain &&
																				isUndefined(
																					mainRackCount.true
																				)) /* || !isUndefined(multiMainRackCount.true)*/
																		}
																	>
																		{translations[elem.translationKey]}
																	</OptionCustom>
																)
															})}
														</SelectInputCustom>
													</SelectInputWrapper>
													{errors.idDisplayStandModel && (
														<ErrorInputMsg>{errors.idDisplayStandModel.message}</ErrorInputMsg>
													)}
												</div>
											</Fragment>
										</KioskCreationDefinitionBusinessRacksPart>
									</Fragment>
								)}
								<KioskCreationDefinitionBusinessRacksPart>
									{/*!isEqual(selectedProfile, {}) && selectedProfile.standardProfile &&
								<Fragment>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_salesmenMessage']} :</LabelText>
									</div>
									<InputWrapper>
										<TextareaStyled
											name="noteCommercial"
											disabled={!isEditable}
											type="text"
											ref={ register( {
												maxLength: {
													value: 300,
													message: `3000 ${translations["common__text__charMax"]}`
												},
												minLength: {
													value: 1,
													message: `1 ${translations["common__text__charMin"]}`
												},
										} ) }
										/>
										{
										errors.noteCommercial &&
										<ErrorInputMsg>{errors.noteCommercial.message}</ErrorInputMsg>
										}
									</InputWrapper>
								</Fragment>
								*/}
									{!isEqual(selectedProfile, {}) /*&& !selectedProfile.standardProfile*/ && !isEqual(selectedRack, {}) && (
										<Fragment>
											<div>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_foldable']} :</LabelText>
											</div>
											<div>
												<Controller
													control={control}
													name="displayStandFolded"
													as={ToggleFilters}
													disabled={!isEditable}
													size="large"
													checked={selectedRack.displayStandFolded}
													reverseCheck
													onChangeHandler={() => {
														handleRackModelSelectedChange('displayStandFolded')
													}}
													rules={register({
														required: {
															value: false,
															message: translations['common__text__requiredField'],
														},
													})}
													labelPrev={translations['common__text__yes']}
													labelNext={translations['common__text__no']}
												/>
											</div>
											<div>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_accessoryModule']} :</LabelText>
											</div>
											<div>
												<Controller
													control={control}
													name="accessoryRack"
													as={ToggleFilters}
													disabled={!isEditable || !selectedRack.allowAccessoryRack}
													size="large"
													checked={selectedRack.accessoryRack}
													reverseCheck
													onChangeHandler={() => {
														handleRackModelSelectedChange('accessoryRack')
													}}
													rules={register({
														required: {
															value: false,
															message: translations['common__text__requiredField'],
														},
													})}
													labelPrev={translations['common__text__yes']}
													labelNext={translations['common__text__no']}
												/>
											</div>
										</Fragment>
									)}
								</KioskCreationDefinitionBusinessRacksPart>
								{selectedRack.accessoryRack && (
									<Fragment>
										<KioskCreationDefinitionBusinessRacksPartAccessory>
											<div>
												<div>
													<LabelText>
														{translations['page_admin_initKiosk_stepOne_sheet_rackNumber']}
														{!stockRequestCheck ? '*' : ''} :
													</LabelText>
												</div>
												<div>
													<SelectInputWrapper>
														<SelectInputCustom
															width="208"
															name="idAccessoryLockersNumber"
															disabled={!isEditable}
															ref={register({
																required: {
																	value: !stockRequestCheck,
																	message: translations['common__text__requiredField'],
																},
																validate: (value) =>
																	(value > 0 && !stockRequestCheck) ||
																	stockRequestCheck ||
																	translations['common__text__requiredField'],
															})}
															className={watch('idAccessoryLockersNumber') > 0 ? 'active' : ''}
														>
															<OptionCustom value="0" hidden>
																{translations['page_admin_initKiosk_stepOne_sheet_rackNumber_placeholder']}
															</OptionCustom>
															{map(selectedRack.accessoryDisplayLockersNumber, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} target={true} selected={elem.selected}>
																		{translations[elem.translationKey]}
																	</OptionCustom>
																)
															})}
														</SelectInputCustom>
													</SelectInputWrapper>
													{errors.idAccessoryLockersNumber && (
														<ErrorInputMsg>{errors.idAccessoryLockersNumber.message}</ErrorInputMsg>
													)}
												</div>
												<div>
													<LabelText>
														{translations['page_admin_initKiosk_stepOne_sheet_accessoryLockerType']}
														{!stockRequestCheck ? '*' : ''} :
													</LabelText>
												</div>
												<div>
													<SelectInputWrapper>
														<SelectInputCustom
															width="208"
															name="idAccessoryDisplayStandModel"
															disabled={!isEditable}
															ref={register({
																required: {
																	value: !stockRequestCheck,
																	message: translations['common__text__requiredField'],
																},
																validate: (value) =>
																	(value > 0 && !stockRequestCheck) ||
																	stockRequestCheck ||
																	translations['common__text__requiredField'],
															})}
															className={watch('idAccessoryDisplayStandModel') > 0 ? 'active' : ''}
														>
															<OptionCustom value="0" hidden>
																{translations['page_admin_initKiosk_stepOne_sheet_accessoryLockerType_placeholder']}
															</OptionCustom>
															{map(selectedRack.accessoryDisplayStandModels, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} target={true} selected={elem.selected}>
																		{translations[elem.translationKey]}
																	</OptionCustom>
																)
															})}
														</SelectInputCustom>
													</SelectInputWrapper>
													{errors.idAccessoryDisplayStandModel && (
														<ErrorInputMsg>{errors.idAccessoryDisplayStandModel.message}</ErrorInputMsg>
													)}
												</div>
											</div>
										</KioskCreationDefinitionBusinessRacksPartAccessory>
									</Fragment>
								)}
								{!isEqual(selectedProfile, {}) /*&& !selectedProfile.standardProfile*/ && !isEqual(selectedRack, {}) && (
									<AddRackButtonWrapper>
										<Link onClick={() => handleRackList('add')} style={{ textDecoration: 'none' }}>
											<Button
												text={translations['page_admin_initKiosk_stepOne_button_addRack']}
												bgColor={Theme.colors.primary}
												height={32}
												iconHeight={15}
												img={AddRack}
											/>
										</Link>
									</AddRackButtonWrapper>
								)}
							</KioskCreationDefinitionBusinessContentPart>
						</KioskCreationDefinitionBusinessColumn>
					</PageWrapperGridsCustom>
				</form>
			</KioskCreationDefinitionBusinessWrapper>
		</Fragment>
	)
}

KioskCreationDefinitionBusiness.propTypes = {}

KioskCreationDefinitionBusiness.defaultPropTypes = {}

export default KioskCreationDefinitionBusiness
